<template>
	<div class="jobDetails" v-if="job">
        <!-- <div> -->
            <!-- Main Body Content area -->
            <div v-loading="loading" class="o-main-content-area o-main-content-area--padBotoomNone c-responsive-fixwidth">

                <!-- Heading Section -->
                <div class="row">
                    <div class="col-md-6">
                        <h1 class="h1">Jobs / Events: <span v-if="job">{{job.title}}</span></h1>
                    </div>
                    <div class="col-md-6 text-right">
                        <ul class="o-filter-area">
                            <li v-if="getPower('editJob')"><a href="javascript: void(0)" @click="cloneJob()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-files-o" aria-hidden="true"></i> Clone Job</a></li>
                            <li v-if="getPower('editJob')"><a href="javascript: void(0)" @click="editJob()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-pencil" aria-hidden="true"></i> Edit Job</a></li>
                            <li v-if="checkDeleteAccess()"><a href="javascript: void(0)" @click="deleteJob()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-red"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete Job</a></li>
                            <li>
                                <a href="javascript: void(0)" v-if="getPower('addCall') || addCallPower()" @click="addBulkCall()" class="c-solid-btn c-solid-btn--small c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add New Call</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- /Heading Section -->

                <!-- Job filter Section -->
                <div class="c-common-space c-common-space--overflowVisible clearfix">
                    <div class="col-md-12 o-no-padding">
                        <div class="custom-row">
                            <div class="custom-col text-left">
                                <ul class="o-custom-filter">
                                    <li><span class="o-blue-medium-text">Job Number:</span> <span>#{{job.job_number}}</span></li>	                            
                                    <li><span class="o-blue-medium-text">Start Date:</span> <span>{{getDate(job.start)}}</span></li>
                                    <li><span class="o-blue-medium-text">End Date:</span> <span>{{getDate(job.end)}}</span></li>
                                    <li>
                                        <span class="o-blue-medium-text">Steward:</span> 
                                        <span v-if="selectedSortType=='fname_desc'">{{job.employee?job.employee.employable.last_name+", "+job.employee.employable.first_name:'NA'}}</span>
                                        <span v-else>{{job.employee?job.employee.employable.first_name+" "+job.employee.employable.last_name:'NA'}}</span>
                                    </li>
                                    <li>
                                        <span class="o-blue-medium-text">Dispatched by:</span> 
                                        <span v-if="selectedSortType=='fname_desc'">{{(job && job.dispatched_by)? job.dispatched_by.last_name+", "+job.dispatched_by.first_name : "NA" }}</span>
                                        <span v-else>{{(job && job.dispatched_by)? job.dispatched_by.first_name+" "+job.dispatched_by.last_name : "NA" }}</span>
                                    </li>	                            
                                </ul>
                            </div>

                            <div class="custom-col outer--border text-left">
                                <ul class="o-custom-filter">
                                    <li><span class="o-blue-medium-text">Employer:</span> <span>{{(job.employer)?job.employer.name:"NA"}}</span></li>
                                    <li><span class="o-blue-medium-text">Employer Contact:</span> <span>{{ displayEmployerContact(job) }}</span></li>
                                    <li><span class="o-blue-medium-text">Payroll:</span> <span>{{(job.payroll) ? job.payroll.name : "NA"}}</span></li>
                                    <li><span class="o-blue-medium-text">Rate Table:</span> <span>{{(rate_table_name!='') ? rate_table_name : "NA"}}</span></li>
                                </ul>
                            </div>

                            <div class="custom-col text-left">
                                <ul class="o-custom-filter">
                                    <li>
                                        <span class="o-blue-medium-text">Global Skills</span>
                                    </li>
                                    <!-- <li><span class="o-blue-medium-text">Employer:</span> <span>{{(job.employer)?job.employer.name:"NA"}}</span></li>
                                    <li><span class="o-blue-medium-text">Employer Contact:</span> <span>{{ displayEmployerContact(job) }}</span></li> -->
                                    <li>
                                        <span class="">1. </span>
                                        <!-- <br />  -->
                                        <span>{{ (positions.length&&job && job.skill_id1) ? getSkillById(job.skill_id1) : "NA" }}</span>
                                    </li>
                                    
                                    <li>
                                        <span class="">2. </span> 
                                        <!-- <br /> -->
                                        <span>{{ (positions.length&&job && job.skill_id2) ? getSkillById(job.skill_id2) : "NA" }}</span>
                                    </li>
                                    <li>
                                        <span class="">3. </span>
                                        <!-- <br />  -->
                                        <span>{{ (positions.length&&job && job.skill_id3) ? getSkillById(job.skill_id3) : "NA" }}</span></li>
                                </ul>
                            </div>
                            
                            <div class="custom-col outer--border text-left">
                                <ul class="o-custom-filter">
                                    
                                    <li>
                                        <div class="o-pub">
                                            <label class="o-blue-medium-text">Delete Call Without Notify:</label>
                                            <div v-if="getPower('silentDelete')" class="toggle-btn">
                                                <el-switch
                                                    style="display: block"
                                                    v-model="job_delete_notify"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value="1"
                                                    :inactive-value="0"
                                                    @change="changeJobDeleteNotify()">
                                                </el-switch>
                                            </div>
                                            <span v-else>{{job_delete_notify==1?'Yes':'No'}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="o-pub">
                                            <label class="o-blue-medium-text">Deny Steward Access: </label>
                                            <div class="toggle-btn" v-if="getPower('silentDelete')">
                                            <!-- <div class="toggle-btn"> -->
                                                <el-switch
                                                    style="display: block"
                                                    v-model="deny_steward_access"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    :active-value="1"
                                                    :inactive-value="0"
                                                    @change="changeDenyStewardAccess()">
                                                </el-switch>
                                            </div>
                                            <span v-else>{{deny_steward_access==1?'Yes':'No'}}</span>
                                        </div>
                                    </li>
                                    <li><span class="o-blue-medium-text">HTS:</span> <span>{{job.hts_flag?'Yes':'No'}}</span></li>
                                    <li>
                                        <div class="o-pub">
                                            <label class="o-blue-medium-text">Pub:</label>
                                            <div v-if="getPower('publishJob')" class="toggle-btn">
                                                <el-switch
                                                    style="display: block"
                                                    v-model="jobStatus"
                                                    active-color="#13ce66"
                                                    inactive-color="#dcdfe6"
                                                    active-value="Published"
                                                    inactive-value="Draft"
                                                    @change="publishedJob()">
                                                </el-switch>
                                            </div>
                                            <span v-else>{{jobStatus=='Published'?'Yes':'No'}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="custom-col text-left">
                                <ul class="o-custom-filter">
                                        <li>
                                        <span class="o-blue-medium-text">Created by:</span> 
                                        <!-- <br /> -->
                                        <span v-if="selectedSortType=='fname_desc'">{{(job && job.created_by)? job.created_by.last_name+", "+job.created_by.first_name : "NA" }} </span>
                                        <span v-else>{{(job && job.created_by)? job.created_by.first_name+" "+job.created_by.last_name : "NA" }} </span>
                                        <br />
                                        <span>{{ getUserDateTimeFormat(job.created_at) }}</span>
                                        
                                    </li>
                                    <li>
                                        <span class="o-blue-medium-text">Updated by:</span> 
                                        <!-- <br /> -->
                                        <span v-if="selectedSortType=='fname_desc'">
                                            {{ job.updated_by?job.updated_by.last_name+", "+job.updated_by.first_name: 'NA'}} <br />
                                        </span>
                                        <span v-else>
                                            {{ job.updated_by?job.updated_by.first_name+" "+job.updated_by.last_name: 'NA'}} <br />
                                        </span>
                                        <span>{{ getUserDateTimeFormat(job.updated_at) }}</span>
                                    </li>
                                    
                                </ul>
                            </div>
                            <div class="custom-col text-center">
                                <ul class="o-custom-filter">
                                    <li>
                                        <div class="time-out-part">
                                            <label><span class="o-blue-medium-text">Global Call Timer:</span></label>

                                            <select class="job-details-call-timeout-disable" placeholder="Days" v-model="globalTimeOut.days" disabled>
                                                <option v-for="(day,dayIndex) in selectConfig.days" :key="dayIndex" :value="day">{{'0'+day}} 
                                                </option>
                                            </select> :
                                            <select class="job-details-call-timeout-disable" placeholder="Hours" v-model="globalTimeOut.hours" disabled >
                                                <option v-for="(hour,hourIndex) in selectConfig.hours" :key="hourIndex" :value="hour">{{hour>=10?hour:'0'+hour}} 
                                                </option>
                                            </select> :
                                            <select class="job-details-call-timeout-disable" placeholder="Minuts" v-model="globalTimeOut.mins" disabled>
                                                <option v-for="(min,minIndex) in selectConfig.mins" :key="minIndex" :value="min">{{min>=10?min:'0'+min}} 
                                                </option>
                                            </select>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="time-out-part">
                                            <label><span class="o-blue-medium-text">Job Call Timer:</span></label>

                                            <select @change="onChangeJobTimeOut()" class="job-details-call-timeout" placeholder="Days" v-model="jobTimeOut.days" :disabled="!getPower('callTimer')">
                                                <option value='' disabled>Days</option>
                                                <option v-for="(day,dayIndex) in selectConfig.days" :key="dayIndex" :value="day">{{'0'+day}} 
                                                </option>
                                            </select> :
                                            <select @change="onChangeJobTimeOut()" class="job-details-call-timeout" placeholder="Hours" v-model="jobTimeOut.hours" :disabled="!getPower('callTimer')">
                                                <option value='' disabled>Hours</option>
                                                <option v-for="(hour,hourIndex) in selectConfig.hours" :key="hourIndex" :value="hour">{{hour>=10?hour:'0'+hour}}
                                                </option>
                                            </select> :
                                            <select @change="onChangeJobTimeOut()" class="job-details-call-timeout" placeholder="Minutes" v-model="jobTimeOut.mins" :disabled="!getPower('callTimer')">
                                                <option value='' disabled>Minutes</option>
                                                <option v-for="(min,minIndex) in selectConfig.mins" :key="minIndex" :value="min">{{min>=10?min:'0'+min}} 
                                                </option>
                                            </select>
                                        </div> 
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- /Job filter Section -->
                <div class="o-ndividualArea">
                    <div class="o-ndividualTable o-ndividualTable--small o-hidden-flow">
                        <div class="col-md-12 text-left o-no-padding">
                            <ul class="o-filter-area">
                                <li><a href="javascript: void(0)" @click="goToCalls()" class="c-common-btn c-common-btn--small">
                                    <i class="fa fa-eye" aria-hidden="true"></i> View Calls</a></li>
                                <li><a href="javascript: void(0)" @click="goToPhoneSheet()" class="c-common-btn c-common-btn--small">
                                    <i class="fa fa-tty" aria-hidden="true"></i> Phone Sheet</a></li>
                                <li><a href="javascript: void(0)" @click="gotoJobAttendance()" class="c-common-btn c-common-btn--small">
                                    <i class="fa fa-table" aria-hidden="true"></i> Attendance</a></li>
                                <li><a href="javascript: void(0)" @click="goSignInSheet()" class="c-common-btn c-common-btn--small">
                                    <i class="fa fa-address-card-o" aria-hidden="true"></i> Sign In Sheet</a></li>
                                <li><a href="javascript: void(0)" @click="gcsSignInSheet()" class="c-common-btn c-common-btn--small">
                                    <i class="fa fa-address-card-o" aria-hidden="true"></i> New Sheet</a></li>
                                <li v-if="getPower('jobCallCsv')"><a href="javascript: void(0)" @click="employeeDownload()" class="c-common-btn c-common-btn--small"><i class="fa fa-download" aria-hidden="true"></i> Employee Data (.csv)</a></li>

                                <!-- <li v-if="getPower('jobCallCsv')&&estimate_payroll_button">
                                    <a href="javascript: void(0)" @click="payrollEstimateTemplate()" class="c-common-btn c-common-btn--small">
                                        <i class="fa fa-usd" aria-hidden="true"></i>
                                            Estimate Payroll
                                    </a>
                                </li> -->
                                <li v-if="estimate_payroll_button">
                                    <a href="javascript: void(0)" @click="downloadGsheet()" class="c-common-btn c-common-btn--small gsheet">
                                        <!-- <i class="fa fa-file-pdf-o" aria-hidden="true"></i> 
                                            Download  -->
                                        <span><img class="gsheet-logo" src="static/assets/images/Document-icon.png" /></span>
                                        <!-- <span class="gsheet-text">G-Sheet</span> -->
                                        <span class="gsheet-text">
                                            <span class="mr1px">$</span>Payroll
                                        </span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="loadWishlistSummaryReportJson" class="c-common-btn c-common-btn--small">
                                        <!-- <i class="fa fa-download" aria-hidden="true"></i> &nbsp; -->
                                            Wishlist Summary 
                                        <!-- <span><img class="gsheet-logo" src="static/assets/images/Document-icon.png" /></span> -->
                                        <!-- <span class="gsheet-text">G-Sheet</span> -->
                                        <!-- <span class="gsheet-text">
                                            <span class="mr1px">$</span>Archive
                                        </span> -->
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <!-- Issues Container -->
                <div class="c-common-space c-common-space--overflowVisible clearfix">
                    <div class="col-sm-12 col-md-6">
                        <div class="row u-common-box-shadow c-radius3">
                            <div class="o-calls-table">
                                <div class="calls-table-row">
                                    
                                    <div class="calls-table-cell table-td-border-right o-no-padding o-assign-leftBox">
                                        <div class="u-pad-all-20 c-bg-white">
                                            <div class="calls-table-cell-inner-table c-employee">
                                                <div class="c-issue--column text-center">
                                                    <div :class="(job.unassigned_calls_count || job.unconfirmed_calls_count)?'c-issue-counter' :(job.issues > 0)?'c-issue-counter':'c-issue-counter o-issue-counter-green'">
                                                        <i :class="(job.unassigned_calls_count || job.unconfirmed_calls_count)?'fa fa-thumbs-down':(job.issues > 0 )?'fa fa-thumbs-down':'fa fa-thumbs-up'" aria-hidden="true"></i>
                                                        <span class="o-issue-couter-sign">{{(job.issues) ? job.issues:'0'}}</span>
                                                    </div>
                                                    <div class="c-issue-counter-details u-pad-top-10">Issues require
                                                        <br />attention</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="calls-table-cell text-left o-no-padding c-bg-blue">
                                        <div class="u-pad-all-10">
                                            <div class="calls-table-row">
                                                
                                                <div class="calls-table-cell calls-table-cell--no-border u-pad-all-5">
                                                    <div class="o-issue-counter-small">{{(job.unassigned_calls_count) ? job.unassigned_calls_count : 0 }}</div>
                                                </div>
                                                    
                                                <div class="calls-table-cell calls-table-cell--no-border u-pad-all-5">
                                                    <div class="o-issue-desc-small">Calls have
                                                        <br />no employee assigned.</div>
                                                </div>
                                                <div class="calls-table-cell calls-table-cell--no-border u-pad-all-5">
                                                    <div style="display:none"><a href="javascript: void(0)" @click="goToAssign()" class="c-common-btn c-common-btn--small o-job-assignBtn">Assign Employee</a></div>
                                                </div>
                                            </div>
                                            <div class="calls-table-row">
                                                
                                                <div class="calls-table-cell calls-table-cell--no-border u-pad-all-5">
                                                    <div class="o-issue-counter-small">{{(job.unconfirmed_calls_count > 0) ? job.unconfirmed_calls_count : 0}}</div>
                                                </div>
                                                    
                                                <div class="calls-table-cell calls-table-cell--no-border u-pad-all-5">
                                                    <div class="o-issue-desc-small">Assignments are
                                                        <br />unconfirmed.</div>

                                                </div>
                                                <div class="calls-table-cell calls-table-cell--no-border u-pad-all-5">
                                                    <div style="display:none"><a href="javascript: void(0)" @click="goToPhoneSheet()" class="c-common-btn c-common-btn--small o-job-assignBtn">Phonesheet</a></div>
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <div class="custom-row u-common-box-shadow c-radius3">
                            <div class="o-calls-table">
                                <div class="o-common-head">	                            
                                    <h5 class="c-common-heading"><i class="fa fa-map-marker" aria-hidden="true"></i> Venue: <label class="c-issue-counter-details">{{full_address_map}}</label></h5>	                       		
                                </div>
                                <div class="o-map-conatiner googleMap">								
                                    <iframe 
                                        v-if="!loading"
                                        width="100%"
                                        height="100%"
                                        frameborder="0" style="border:0"
                                        :src="getMapUrl()" allowfullscreen>
                                    </iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="c-common-space c-common-space--overflowVisible clearfix o-no-margin-top10">
                    <div class="col-md-6 o-no-padding o-no-margin-top10">
                        <div class="col-lg-3 col-md-6 o-no-padding">
                            <h5 class="h2 o-no-margin-bottom">Employer Request: </h5>
                        </div>
                        <div class="col-md-1">
                            <div class="o-table-block-btn o-no-margin-top10">
                                <a data-v-a5fb67ec="" 
                                href="javascript: void(0)" 
                                :class="{'greyBg': userRoleSlug=='auditor'}" 
                                @click="openEditRequestCommentModal('Employer Request')">
                                    <i data-v-a5fb67ec="" aria-hidden="true" class="fa fa-pencil"></i>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-6 o-no-margin-top10 o-no-padding">
                                <div class="o-pub">
                                    <label class="o-blue-medium-text">Hide in Calendar:</label>
                                    <div v-if="getPower('publishJob')" class="toggle-btn">
                                        <el-switch
                                            style="display: block"
                                            v-model="employer_request_flag"
                                            active-color="#13ce66"
                                            inactive-color="#dcdfe6"
                                            :active-value=1
                                            :inactive-value=0
                                            @change="publishEmployerRequest()">
                                        </el-switch>
                                    </div>
                                    <span v-else>{{ employer_request_flag == 1 ? 'Yes' : 'No' }}</span>
                                <!-- </div>
                                <div class="o-pub o-no-margin-top10"> -->
                                    <label class="o-blue-medium-text o-padding-left-10">Print With Sign in Sheet:</label>
                                    <div v-if="getPower('publishJob')" class="toggle-btn">
                                        <el-switch
                                            style="display: block"
                                            v-model="employer_requests_signin"
                                            active-color="#13ce66"
                                            inactive-color="#dcdfe6"
                                            :active-value=1
                                            :inactive-value=0
                                            @change="publishPrintWithSignIn()"
                                            >
                                        </el-switch>
                                    </div>
                                    <span v-else>{{ employer_request_flag == 1 ? 'Yes' : 'No' }}</span>
                                </div>
                        </div>
                        <div class="col-md-12 o-no-padding">
                            <div v-if="employer_request!==''" class="o-notes-toggle-container c-common-box-shadow c-radius3 o-no-margin-top10">
                                    <!-- <div class="o-toggle-header"> -->
                                    <div class="o-toggle-content o-uploaded-doc-owner">
                                    
                                        <div id="add-call" class="o-file-strip-light word-break">
                                                <span class="ps1" v-if="job" v-html="employer_request"></span>
                                        </div>															
                                    </div>
                            </div>
                            <div class="o-no-margin-top10" v-if="employer_request === ''">
                                    <div class="ps1 o-attachment-strip">No Employer Requests Found</div>
                            </div>
                                    <!-- </div> -->
                        </div>
                    </div>
                    <div class="col-md-6 o-no-padding o-no-margin-top10">
                            <div class="col-lg-4 col-md-5">
                                    <h5 class="h2">Calendar Comments:</h5>
                            </div>
                            <div class="col-md-1">
                                <div class="o-table-block-btn o-no-margin-top10">
                                    <a data-v-a5fb67ec="" 
                                    href="javascript: void(0)" 
                                    :class="{'greyBg': userRoleSlug=='auditor'}" 
                                    @click="openEditRequestCommentModal('Calender Comments')">
                                        <i data-v-a5fb67ec="" aria-hidden="true" class="fa fa-pencil"></i>
                                    </a>
                                </div>
                        </div>
                        <div class="col-lg-7 col-md-5 o-left-no-padding o-no-margin-top10">
                                <div class="checkbox o-custom-radio o-modal-form-field">
                                        <label>
                                                <sup>*</sup> Comments- ALWAYS printed with sign-in and calendar info !
                                        </label>
                                </div>
                        </div>


                        <div class="col-md-12" v-if="calender_comments!==''">
                                    <div class="o-notes-toggle-container c-common-box-shadow c-radius3 o-no-margin-top10">
                                            <div class="o-toggle-content o-uploaded-doc-owner">
                                                    
                                                <div id="add-call" class="o-file-strip-light word-break">
                        <span class="ps1" v-if="job" v-html="calender_comments"></span>
                    </div>															
                                            </div>
                                    </div>
                            </div>
                            <div v-if="calender_comments === ''" class="col-md-12">
                                        <div class="ps1 o-attachment-strip">No Calender Comments found</div>
                            </div>						
                    </div>
                </div>


                <!-- /Issues Container -->
                <!-- Notes and documentation -->
                <div class="c-common-space c-common-space--overflowVisible clearfix" >
                        <!-- ||  (config_arr.indexOf('notes') > -1)) -->
                        <!-- v-if="(userRoleSlug == 'client-admin' || userRoleSlug == 'power-user')" -->
                            <div class="col-md-6 o-no-padding">
                        <div class="col-md-12 o-no-padding">
                            <h5 class="h2 o-no-margin-bottom">Notes:</h5>
                        </div>
                        <div class="col-md-12 o-no-padding fixed-height-box">
                            <div class="o-notes-toggle-container c-common-box-shadow c-radius3 o-no-margin-top10">
                                <div v-for="(note,key) in notes" :key="key" v-bind:class="(key==0)?'js-active-togg':''"  class="o-toggle-header">
                                    <a href="javascript: void(0)" v-on:click="toggleHeader(key)" :id="key" class="o-toggle-trigger">
                                        <i v-bind:class="(key==0)?'fa-minus-circle':'fa-plus-circle'" class="fa " aria-hidden="true"></i>
                                    </a>
                                    <div class="o-toggle-content o-uploaded-doc-owner">
                                        <div v-bind:class="(key==0)?'js-togg-expand-height':''"  class="js-note-txt-expand ">
                                            <p class="ps1">{{ note.content }}</p>
                                        </div>
                                        <div class="o-inlineblock o-attachmentdate">
                                            <i class="fa fa-calendar" aria-hidden="true"></i> {{getDateUtc(note.created_at)}} <i class="fa fa-clock-o" aria-hidden="true"></i> {{getTimeUtc(note.created_at)}}
                                        </div>
                                        <h5 class="ps2">Dispatched by: {{ getNoteAuthor(note) }}
                                        <a href="javascript: void(0)" @click="editSingleNotes(note)" v-show="(getNoteAuthor(note)=='Me')? true:false"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                                        <a @click="deleteNote(note.id)" href="javascript: void(0)" v-if="(getNoteAuthor(note)=='Me')? true:false"><i class="fa fa-trash-o" aria-hidden="true"></i></a></h5>
                                    </div>
                                </div>
                                <div v-if="notes.length == 0" class="">
                                    <div class="o-attachment-strip">No note found</div>
                                </div>

                            </div>
                        </div>
                        <div v-if="getPower('addNote')" class="col-md-12 o-no-padding">
                            <a href="javascript: void(0)" @click="addSingleNotes()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Note</a>
                        </div>
                    </div>
                    <div class="col-md-6 o-no-padding">
                        <div class="col-md-12">
                            <h5 class="h2">Documents:</h5>
                        </div>
                        <div v-if="attachmentList.length>0" class="col-md-12">
                            <div class="o-notes-toggle-container c-bg-white u-pad-all-15 c-common-box-shadow c-radius3 no-margin-top">
                                <ul class="o-documents-container">
                                    <li v-for="(attachment, key, index) in attachmentList" :key="key">
                                        <div class="col-md-4 o-no-padding o-uploaded-doc">
                                            <span><i class="fa fa-file-o" aria-hidden="true"></i></span> {{snippet(attachment.filename)}}
                                        </div>
                                        <div class="col-md-8 o-no-padding text-right o-uploaded-doc-owner">
                                            <div class="o-inlineblock o-attachmentdate created-time-width">
                                                <i class="fa fa-calendar" aria-hidden="true"></i> {{getDateUtc(job.attachments[key].created_at)}} <i class="fa fa-clock-o" aria-hidden="true"></i> {{getTimeUtc(job.attachments[key].created_at)}}
                                            </div>
                                            <div class="o-inlineblock text-right action-icon-doc-width">
                                                <h5>
                                                    Created by: {{ getNoteAuthor(attachment) }} <a href="javascript: void(0)" @click="deleteAttachment(attachment.id)" v-show="(getNoteAuthor(attachment)!='Me')? false:true"><i v-show="(getNoteAuthor(attachment)!='Me')? false:true" class="fa fa-trash-o" aria-hidden="true"></i></a>
                                                    <a href="javascript: void(0)" @click="show(0 , key, attachment.filename, attachment.path)" class="o-files-view"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                                        <a :href="getBaseURL + 'api/v2/auth/'+ decodeFileId(attachment.id)+'/download'" :class="'files'+index+key" download class="o-files-download"><i class="fa fa-cloud-download" aria-hidden="true"></i></a>
                                                        <a href="javascript: void(0)" @click="copyDocumentLink(attachment.path)"><i class="fa fa-copy"></i></a>
                                                </h5>

                                                <div :class="'images0'+key" v-viewer="{movable: true}">
                                                    <img :src="attachment.path" :key="attachment.path" v-show="false">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12 o-no-padding share-access-style">
                                            <label>Display In Calendar:</label>  
                                            <input type="radio" @change="changeShareAccess(attachment.id, attachment.shareable)" v-model="attachment.shareable" value="1" :name="attachment.id" :id="'share1'+attachment.id">
                                            <span>Yes</span>
                                            <input type="radio" @change="changeShareAccess(attachment.id, attachment.shareable)" v-model="attachment.shareable" value="0" :name="attachment.id" :id="'share2'+attachment.id">
                                            <span>No</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div v-if="attachmentList.length == 0" class="col-md-12">
                            <div class="o-file-strip c-common-box-shadow">No Document uploaded</div>
                        </div>
                        <div class="col-md-12">
                            <h5 class="h2">Upload Documents:</h5>
                        </div>
                        <div v-if="getPower('addFile')" class="col-md-12">
                            <ul class="o-filter-area">
                                <li>
                                    <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                        <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> Add Files</button>
                                        <input type="file"  accept=".wks,.wps,.tex,.rtf.csv,.xlr,.doc,.docx,.odp,.ods,.odt,.pdf,.ppt,.pptx,.xls,.xlsx,.bmp,.gif,.ico,.jpeg,.jpg,.png,.svg,.tif,.tiff,.webp,.aac,.mid,.midi,.mp3,.oga,.opus,.wav,.weba,.3gp,.3g2,.avi,.mp4,.mpeg,.ogv,.ts,.webm,.txt,.text"  @change="addFileToList($event)" />
                                    </label>
                                </li>
                                <li><a href="javascript: void(0)" @click="uploadImage()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-upload" aria-hidden="true"></i> Start Upload</a></li>
                                <li><a href="javascript: void(0)" @click="cancelUpload()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel Upload</a></li>
                                <li><a href="javascript: void(0)" @click="deleteDocuments()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete</a></li>
                            </ul>
                        </div>
                        <div class="col-md-12">
                            <div class="upload-table-list o-uploaded-box c-common-box-shadow">
                                <div class="calls-table-row o-upload-devider" v-for="(img,key) in new_files" :key="key" v-loading.this.lock="img.uploading">
                                    <div class="calls-table-cell">
                                        <div class="checkbox o-custom-radio">
                                            <label>
                                                <input type="checkbox" :name="key" value="" v-model="img.status">
                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                            </label>
                                        </div>
                                    </div>
                                <div class="calls-table-cell">

                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext user-icon o-uploaded-image o-no-padding-left">
                                            <div class="o-post-logged o-post-logged--table-user">
                                                <div class="o-user-profile-img o-user-profile-img--upload">
                                                    <img v-if="!img.fileExtension" :src="img.img">
                                                    <img v-else src="static/assets/images/Document-icon.png">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <div>{{img.name}}</div>
                                        </div>
                                        <div class="o-accordion-subtext user-icon o-uploaded-image">
                                            <div class="o-post-logged o-post-logged--table-user">

                                                <div class="o-cutsomSelect o-cutsomSelect--inline o-custom-drop">
                                                    <select v-model="new_files[key].label">
                                                        <option value="Report">Report</option>
                                                        <option value="HW">HW</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                        <el-progress :percentage="img.progress" :status="(img.progress == 100)?'success':''"></el-progress>
                                </div>
                            </div>
                            <div v-if="new_files.length == 0" class="">
                                <div class="o-attachment-strip">Upload your Documents</div>
                            </div>

                        </div>
                    </div>
                    <div v-if="new_files.length > 0" class="col-md-12">
                        <ul class="o-filter-area">
                            <li>
                                <a href="javascript: void(0)" @click="cancelSave()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                            </li>
                            <li>
                                <a href="javascript: void(0)" @click="uploadSave()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                            </li>
                        </ul>
                    </div>
                        </div>
            </div>
            <!-- /Notes and documentation -->

            </div>
        <!-- </div> -->


        <div v-if="loading" v-loading="loading" class="loading-block"></div>
	    <!-- /Main Body Content area -->

		<modal name="edit-job" height="auto" :clickToClose="false" :scrollable="true" class="modal-dialog modal-sm modal--custom" width="100%">
            <div tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header text-center">
                            <button @click="closeEditJob()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                            <h1 class="modal-title">Edit Job</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            <form>

                                <div class="row" gutter="30" v-if="!modalDataLoad">
                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Event Name:<sup>*</sup></label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <input type="text" id="event-name" class="form-control" placeholder="Event Name" v-validate="{ required: true}" name="Event" v-model="addJob.title">
                                                        <span v-show="errors.has('Event') && this.validation_err!=0" class="err-msg">{{ errors.first('Event') }}</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-sm-6 o-modal-field-area">
                                        <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                            <label class="common-label-text common-label-text--modalwidth">Start Date:<sup>*</sup></label>
                                        </div>
                                        <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                            <div class="row">
                                                <div class="col-sm-5 o-modal-form-field">
                                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                                        <el-col :span="50">
                                                            <el-date-picker
                                                            type="date"
                                                            :placeholder="getDatePlaceholder()"
                                                            style="width: 100%;"
                                                            v-validate="{required: true}"
                                                            name="StartAddDate"
                                                            v-model="addJob.start"
                                                            :format="getDisplayFormat()"
                                                            value-format="yyyy-MM-dd"
                                                            >
                                                            </el-date-picker>
                                                            <span v-show="errors.has('StartAddDate') && this.validation_err!=0" class="err-msg">{{ errors.first('StartAddDate') }}</span>
                                                            </el-col>
                                                    </label>
                                                </div>
                                                <div class="col-sm-2 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                    <label class="common-label-text common-label-text--modalwidth">End Date:<sup>*</sup></label>
                                                </div>
                                                <div class="col-sm-5 o-left-no-padding o-modal-form-field">
                                                    <label class="common-label-input--modalwidth o-custom-dropdown">
                                                        <el-col :span="50">
                                                            <el-date-picker
                                                            type="date"
                                                            :placeholder="getDatePlaceholder()"
                                                            style="width: 100%;"
                                                            v-validate="{ required: true}"
                                                            name="end"
                                                            v-model="addJob.end"
                                                            :format="getDisplayFormat()"
                                                            :picker-options="pickerOptions1"
                                                            value-format="yyyy-MM-dd">
                                                            </el-date-picker>
                                                            <span v-show="errors.has('end') && this.validation_err!=0" class="err-msg">{{ errors.first('end') }}</span>
                                                        </el-col>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-loading="modalDataLoad">

                                    <div class="row">
                                        <div class="col-sm-6 o-modal-field-area">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Location:<sup>*</sup></label>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <select v-validate="'required'" @blur="blur($event)" @change="addLocationDetails(addJob.venue_id)" v-model="addJob.venue_id" class="form-control" name="Location" data-vv-delay="500">
                                                        <option value="">--- Select ---</option>
                                                        <option v-for="(venue,index) in venues" :key="index" :value="venue.id">{{venue.name}}</option>
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                    <span v-show="errors.has('Location') && this.validation_err!=0" class="err-msg">{{ errors.first('Location') }}</span>
                                                </label>
                                                <span v-if="getPower('addVenue')"><a href="javascript: void(0)" @click="addVenueAddress()" class="fl-right"><i class="fa fa-plus" aria-hidden="true"></i> Add Venue</a></span>
                                            </div>
                                        </div>

                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Location Details:</label>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                <label class="common-label-input--modalwidth o-custom-dropdown">
                                                    <textarea v-model="addJob.location_details" class="form-control" rows="2" placeholder="Text Area"></textarea>
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 o-modal-field-area">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Employer: <sup>*</sup></label>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                <div class="row">
                                                    <div class="col-sm-4 o-right-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            <select @blur="blur($event)" @change="addEmployerContact(addJob.hiring_organization_id)" v-model="addJob.hiring_organization_id" class="form-control" v-validate="{ required: true}" name="Employer" data-vv-delay="500">
                                                                <option value="">--- Select ---</option>
                                                                <option v-for="(employer,index) in employers" :key="index" :value="employer.employer_id">{{employer.employer.name}}</option>
                                                            </select>
                                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                            <span v-show="errors.has('Employer') && this.validation_err!=0" class="err-msg">{{ errors.first('Employer') }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-2 o-right-no-padding o-modal-form-field">
                                                        <label class="common-label-text common-label-text--modalwidth">Payroll:</label>
                                                    </div>
                                                    <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            <select @blur="blur($event)" v-model="addJob.payroll_id" class="form-control" name="Payroll" data-vv-delay="500">
                                                                    <option value="">--- Select ---</option>
                                                                    <option v-for="(payroll,index) in payrolls" :key="index" :value="payroll.payroll_id">{{payroll.name}}</option>
                                                            </select>
                                                            
                                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-6 o-modal-field-area">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Employer Contact:</label>    
                                            </div>
                                            <div class="col-sm-9 o-modal-form-field">
                                                <div class="row">
                                                    <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown min-with-select-box">
                                                            <select @blur="blur($event)" v-model="addJob.employer_contact" class="form-control" name="employer_contact" data-vv-delay="500">
                                                                <option value="">--- Select ---</option>
                                                                <option v-for="(user,index) in employer_users" :key="index" :value="user.user.id">{{user.user.first_name}}</option>
                                                                <!-- {{user.user.last_name+', '+user.user.first_name}} -->
                                                            </select>
                                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                            <!-- <span v-show="errors.has('Employer') && this.validation_err!=0" class="err-msg">{{ errors.first('Employer') }}</span> -->
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-2 o-right-no-padding o-modal-form-field">
                                                        <label class="common-label-text common-label-text--modalwidth">HTS:<!-- <sup>*</sup> --></label>
                                                    </div>
                                                    <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            <!-- <select @blur="blur($event)" v-model="addJob.hts_flag" class="form-control" name="Payroll" data-vv-delay="500">
                                                                    <option :value="1">Yes</option>
                                                                    <option :value="0">No</option>
                                                            </select> -->
                                                            <el-switch
                                                                style="display: block"
                                                                v-model="addJob.hts_flag"
                                                                active-color="#13ce66"
                                                                inactive-color="#dcdfe6"
                                                                :active-value=1
                                                                :inactive-value=0                                              
                                                                >
                                                            </el-switch>
                                                        
                                                            <!-- <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span> -->
                                                        </div>
                                                        
                                                    </div>

                                                    <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            <select v-model="addJob.rate_id" class="form-control" name="rate_table" data-vv-delay="500">
                                                                <option value="">--- Select ---</option>
                                                                <option v-for="(rate,index) in rates" :key="index" :value="rate.id">{{rate.name}}</option>
                                                            </select>
                                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                        </div>                                                    
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Steward:<sup>*</sup></label>
                                            </div>
                                            <div class="col-sm-9 o-right-no-padding o-modal-form-field">
                                                <div class="row">
                                                    <div class="col-sm-5 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            <el-select v-model="addJob.employee_id" filterable placeholder="Select Steward" @blur="blur($event)" v-validate="{ required: true}" name="steward" data-vv-delay="500">
                                                                <el-option
                                                                    v-for="(steward,index) in stewards"
                                                                    :key="index"
                                                                    :label="steward.last_name+', '+steward.first_name"
                                                                    v-validate="'required'"
                                                                    :value="steward.id">
                                                                </el-option>
                                                            </el-select>
                                                            <!-- <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span> -->
                                                            <span v-show="errors.has('steward') && this.validation_err!=0" class="err-msg">{{ errors.first('steward') }}</span>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-4 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                        <label class="common-label-text common-label-text--modalwidth">Deny Steward Access:<sup>*</sup></label>
                                                    </div>

                                                    <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                        <!-- <input v-model="addJob.steward_access_flag" type="checkbox" name="o4"> -->
                                                        <!-- <span class="cr"><i class="cr-icon fa fa-check"></i></span> -->
                                                        <el-switch
                                                        style="display: block"
                                                        v-model="addJob.steward_access_flag"
                                                        active-color="#13ce66"
                                                        inactive-color="#dcdfe6"
                                                        :active-value=0
                                                        :inactive-value=1                                               
                                                        >
                                                        </el-switch>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-sm-6 o-modal-field-area">
                                            <div class="col-sm-3 o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Dispatched by:<sup>*</sup></label>
                                            </div>

                                            <div class="col-sm-9 o-modal-form-field">
                                                <div class="row"> 

                                                    <div class="col-sm-5 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                        <label class="common-label-input--modalwidth o-custom-dropdown">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            
                                                            <el-select v-model="addJob.dispatched_by" @blur="blur($event)" filterable placeholder="Select Steward" v-validate="{ required: true }" name="createdBy" data-vv-delay="500">
                                                                <el-option
                                                                    v-for="(steward,index) in dispatchedList"
                                                                    :key="index"
                                                                    :label="steward.last_name+', '+steward.first_name"
                                                                    :value="steward.user_id">
                                                                </el-option>
                                                            </el-select>
                                                            <!-- <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span> -->
                                                            <span v-show="errors.has('createdBy') && this.validation_err!=0" class="err-msg">{{ errors.first('createdBy') }}</span>
                                                        </div>
                                                        </label>
                                                    </div>
                                                    <div class="col-sm-3 o-left-no-padding o-right-no-padding o-modal-form-field">
                                                        <label class="common-label-text common-label-text--modalwidth">Link Color:<sup>*</sup></label>
                                                    </div>
                                                    <div class="col-sm-2 o-left-no-padding o-modal-form-field">
                                                        <div class="common-label-input--modalwidth o-custom-dropdown">
                                                            <el-color-picker v-model="addJob.link_color"></el-color-picker>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>   
                                    </div>

                                    <div class="row" v-if="global_skills">
                                    <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <div class="common-label-input--modalwidth o-custom-dropdown min-with-select-box">
                                                    <label class="common-label-text common-label-text--modalwidth">Global Skills: </label>
                                                </div>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                <div class="col-sm-4 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                    <select @blur="blur($event)" v-model="addJob.skill_id1" class="form-control" data-vv-delay="500"  v-if="positions.length">
                                                        <option value="" label="--- Select ---"></option>
                                                        <option v-for="(position,index) in positions" :value="position.id" :key="index">{{position.name}}</option>
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                            
                                                </div>
                                                <div class="col-sm-4 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                    <select @blur="blur($event)" v-model="addJob.skill_id2" class="form-control" data-vv-delay="500" v-if="positions.length">
                                                        <option value="" label="--- Select ---"></option>
                                                        <option v-for="(position,index) in positions" :value="position.id" :key="index">{{position.name}}</option>
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                </div>
                                                <div class="col-sm-4 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                    <select @blur="blur($event)" v-model="addJob.skill_id3" class="form-control" data-vv-delay="500"  v-if="positions.length">
                                                        <option value="" label="--- Select ---"></option>
                                                        <option v-for="(position,index) in positions" :value="position.id" :key="index">{{position.name}}</option>
                                                    </select>
                                                    <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                </div>
                                                <div class="col-sm-1 o-right-no-padding o-left-no-padding o-modal-form-field">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-12">
                                                <!-- <div class="checkbox o-custom-radio">
                                                    <label>
                                                        <sup class="font-bl"> ** </sup> Global Skills, Once set cannot be undone. Assigned employees Must have skills added to qualify. If change is needed to global skills, the job must be deleted and created again without that global skill.
                                                        
                                                    </label>
                                                </div> -->
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Employer Request:</label>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                                <vue-editor id="editor1" class="c-common-box-shadow c-radius3" v-model="addJob.employer_requests" style="height: 220px;"></vue-editor>
                                            </div>
                                        </div>

                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">
                                                <label class="common-label-text common-label-text--modalwidth">Comments:</label>
                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field" style="max-width: 0px;">
                                                <vue-editor id="editor2" class="c-common-box-shadow c-radius3" v-model="addJob.comment" style="height: 220px;"></vue-editor>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-6 o-modal-field-area">
                                            <div class="col-sm-3 o-right-no-padding o-modal-form-field">

                                            </div>
                                            <div class="col-sm-9 o-left-no-padding o-modal-form-field o-common-margin-bottom15">
                                                <div class="o-pub">
                                                    <label class="o-blue-medium-text">Hide in Calender:</label>
                                                    <div class="toggle-btn">
                                                        <el-switch
                                                        style="display: block"
                                                        v-model="addJob.employer_requests_private"
                                                        active-color="#13ce66"
                                                        inactive-color="#dcdfe6"
                                                        :active-value=1
                                                        :inactive-value=0                                                
                                                        >
                                                        </el-switch>
                                                    </div>
                                                    <label class="o-blue-medium-text o-left-padding-10"> Print With Sign in Sheet:</label>
                                                    <div class="toggle-btn">
                                                        <el-switch
                                                        style="display: block"
                                                        v-model="addJob.employer_requests_signin"
                                                        active-color="#13ce66"
                                                        inactive-color="#dcdfe6"
                                                        :active-value=1
                                                        :inactive-value=0                                                
                                                        >
                                                        </el-switch>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6 o-modal-field-area o-common-margin-bottom15">
                                            <div class="col-sm-12 o-modal-field-area o-common-margin-bottom15">
                                                <div class="col-sm-3 o-right-no-padding o-modal-form-field">

                                                </div>
                                                <div class="col-sm-9 o-left-no-padding o-modal-form-field">
                                                    <div class="checkbox o-custom-radio">
                                                        <label>
                                                            <sup>*</sup> Comments- ALWAYS printed with sign-in and calendar info !
                                                            <!-- <input v-model="addJob.comment_private" type="checkbox" name="o4" value="" checked>
                                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span> -->
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </form>
                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <button @click="closeEditJob()" type="button" class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue" data-dismiss="modal" aria-label="Close"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</button>
                                </li>
                                <li>
                                    <button type="button" class="btn c-solid-btn c-solid-btn--large c-solid-btn--green" @click="editSingleJob()"><i class="fa fa-pencil" aria-hidden="true"></i> Edit Job</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>

		<modal name="add-single-call"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
                    <div role="document">
                            <div class="modal-content o-common-modal-content">
                    <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeSingleCall()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Add Call</h1>
                    </div>
                    <div class="modal-body c-common-box-shadow o-modal-body">
                            <div class="row">
                                    <div class="col-sm-12">
                                            <h2 class="h2 text-center o-modal-link"><a href="javascript:void(0)">{{job.title}}</a></h2>

                                            <div class="o-accordion-subtext o-rowtable-text form-inline text-center">
                                                    <div class="form-group o-popover-blockfield o-modal-inline-field text-center">
                                                            <label for="email">Select Date:</label>
                                                            <input type="text" class="form-control" placeholder="01:59 AM">
                                                    </div>
                                            </div>
                                    </div>
                            </div>
                            <div class="row">
                                    <div class="col-sm-12">
                                            <hr class="o-modal-separetor" />
                                    </div>
                            </div>
                            <div class="row">
                                    <div class="col-sm-6">
                                            <div class="form-group ">
                                                    <label class="common-label-text">Start Time:</label>
                                                    <label class="common-label-input">
                                                            <input type="text" class="form-control" placeholder="01:59 AM">
                                                    </label>
                                            </div>
                                    </div>
                                    <div class="col-sm-6">
                                            <div class="form-group ">
                                                    <label class="common-label-text">End Time:</label>
                                                    <label class="common-label-input">
                                                            <input type="text" class="form-control" placeholder="01:59 AM">
                                                    </label>
                                            </div>
                                    </div>
                                    <div class="col-sm-12">
                                            <div class="form-group">
                                                    <label class="common-label-text common-label-text--fullwidth">Position:</label>
                                                    <label class="common-label-input--fullwidth o-custom-dropdown">
                                                            <select class="form-control">
                                                                    <option>A- Test</option>
                                                                    <option>A-2</option>
                                                                    <option>Audio (Monitors)</option>
                                                                    <option>Audio Assist</option>
                                                                    <option>Boom Lift </option>
                                                                    <option>Camera Op - Robotic</option>
                                                                    <option>Camera Op- Handheld</option>
                                                                    <option>Electrician</option>
                                                            </select>
                                                            <span class="o-custom-drop-arrow"><i class="fa fa-angle-down" aria-hidden="true"></i></span>
                                                    </label>
                                            </div>
                                    </div>
                                    <div class="col-sm-6">
                                            <div class="form-group ">
                                                    <label class="common-label-text">Quantity:</label>
                                                    <label class="common-label-input">
                                                            <input type="text" class="form-control" placeholder="01:59 AM">
                                                    </label>
                                            </div>
                                    </div>
                                    <div class="col-sm-6">
                                            <div class="form-group ">
                                                    <label class="common-label-text">Rate:</label>
                                                    <label class="common-label-input">
                                                            <input type="text" class="form-control" placeholder="01:59 AM">
                                                    </label>
                                            </div>
                                    </div>
                                    <div class="col-sm-12">
                                            <div class="form-group">
                                                    <label class="common-label-text common-label-text--fullwidth">Notes:</label>
                                                    <label class="common-label-input--fullwidth">
                                                            <textarea class="form-control" rows="5" placeholder="Type your notes"></textarea>
                                                    </label>
                                            </div>
                                    </div>

                            </div>
                    </div>

                    <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                    <li>
                                            <a href="javascript: void(0)" @click="closeSingleCall()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                    </li>
                                    <li>
                                            <a href="javascript: void(0)" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                                    </li>
                            </ul>
                    </div>

            </div>
                            <!-- /.modal-content -->
                    </div>
                    <!-- /.modal-dialog -->
            </div>
		</modal>

		<modal name="add-single-notes" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
		    <div tabindex="-1" role="dialog">
		        <div role="document">
		            <div class="modal-content o-common-modal-content">
		                <div class="modal-header u-no-border text-center modal-header--heading">
		                    <button @click="closeSingleNotes()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
		                    <h1 class="modal-title">Add Notes</h1>
		                </div>
		                <div class="modal-body c-common-box-shadow o-modal-body">

		                    <div class="row">
		                        <div class="col-sm-12">
		                            <div class="form-group">
		                                <label class="common-input--fullwidth">
		                                    <textarea class="form-control" rows="4" placeholder="Type your note" v-validate="{required: true, max:1000}" name="note" v-model="addEmployer.note"></textarea>
		                                    <span v-show="errors.has('note') && this.validation_err!=0" class="err-msg">{{ errors.first('note') }}</span>
		                                </label>
		                            </div>
		                        </div>

		                    </div>
		                </div>

		                <div class="modal-footer text-center">
		                    <ul class="o-filter-area">
		                        <li>
		                            <a href="javascript: void(0)" @click="closeSingleNotes()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
		                        </li>
		                        <li>
		                            <a href="javascript: void(0)" @click="addNewNote()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
		                        </li>
		                    </ul>
		                </div>

		            </div>
		            
		        </div>
		        
		    </div>
		</modal>
		<modal name="edit-job-add-note" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
		    <div tabindex="-1" role="dialog" v-loading="modalLoading">
		        <div role="document">
		            <div class="modal-content o-common-modal-content">
		                <div class="modal-header u-no-border text-center modal-header--heading">
		                    <button @click="closeEditJobNote()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
		                    <h1 class="modal-title">Add Notes</h1>
		                </div>
		                <div class="modal-body c-common-box-shadow o-modal-body">
		                    <div class="row">
		                        <div class="col-sm-12">
		                            <div class="form-group">
		                                <label class="common-input--fullwidth">
		                                    <!-- <textarea class="form-control" rows="4" placeholder="Type your note" v-validate="{required: true, max:1000}" name="note" v-model="addEmployer.note"></textarea> -->
		                                    <!-- <span v-show="errors.has('note') && this.validation_err!=0" class="err-msg">{{ errors.first('note') }}</span> -->
		                                    <textarea class="form-control" rows="4" placeholder="Enter your note" name="note" v-model="editJobAddNote.note"></textarea>
		                                </label>
		                            </div>
		                        </div>

		                    </div>
		                </div>

		                <div class="modal-footer text-center">
		                    <ul class="o-filter-area">
		                        <li>
		                            <a href="javascript: void(0)" @click="closeEditJobNote()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
		                        </li>
		                        <li>
		                            <a href="javascript: void(0)" @click="editJobAddNewNote()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
		                        </li>
		                    </ul>
		                </div>

		            </div>
		            
		        </div>
		        
		    </div>
		</modal>

		<modal name="edit-single-notes" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
		    <div tabindex="-1" role="dialog">
		        <div role="document">
		            <div class="modal-content o-common-modal-content">
		                <div class="modal-header u-no-border text-center modal-header--heading">
		                    <button @click="closeEditSingleNotes()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
		                    <h1 class="modal-title">Edit Notes</h1>
		                </div>
		                <div class="modal-body c-common-box-shadow o-modal-body">

		                    <div class="row">
		                        <div class="col-sm-12">
		                            <div class="form-group">
		                                <label class="common-input--fullwidth">
		                                    <textarea class="form-control" rows="4" placeholder="Edit your note" v-validate="{required: true}" name="note" v-model="addEmployer.note"></textarea>
		                                    <span v-show="errors.has('note') && this.validation_err!=0" class="err-msg">{{ errors.first('note') }}</span>
		                                </label>
		                            </div>
		                        </div>

		                    </div>
		                </div>

		                <div class="modal-footer text-center">
		                    <ul class="o-filter-area">
		                        <li>
		                            <a href="javascript: void(0)" @click="closeEditSingleNotes()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
		                        </li>
		                        <li>
		                            <a href="javascript: void(0)" @click="editNewNote()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
		                        </li>
		                    </ul>
		                </div>

		            </div>
		            <!-- /.modal-content -->
		        </div>
		        <!-- /.modal-dialog -->
		    </div>
		</modal>

		<modal name="bulk-call"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
			<div class="employee-summary" tabindex="-1" role="dialog">
				<div  role="document">
					<!-- .modal-content -->
					<div class="modal-content o-common-modal-content">

						<!-- .modal-header -->
						<div class="modal-header u-no-border text-center modal-header--heading">
							<button @click="closeBulkModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
							<h4 class="modal-title">Add Calls</h4>
						</div>
						<!-- /.modal-header -->

						<!-- .modal-body -->
						<div class="modal-body c-common-box-shadow o-modal-body">
							<!--modal-Body-fixed -->
							<div class="bulk-filter">
										<h2 class="h2 text-center o-modal-link">{{job.title}}</h2>
										<div class="c-common-space o-subtitleHeading text-center">
												<label>Group by: </label>
												<span>
														<div class="checkbox o-custom-radio">
																<label>
																		Position
																		<input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.position">
																		<span class="cr"><i class="cr-icon fa fa-check"></i></span>
																</label>
														</div>
												</span>
												<span>
														<div class="checkbox o-custom-radio">
																<label>
																		Start time
																		<input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.startTime">
																		<span class="cr"><i class="cr-icon fa fa-check"></i></span>
																</label>
														</div>
												</span>
												<span>
														<div class="checkbox o-custom-radio">
																<label>
																		End time
																		<input type="checkbox" id="checkbox" @change="onInputchangeCheckbox" v-model="modalFilter.endTime">
																		<span class="cr"><i class="cr-icon fa fa-check"></i></span>
																</label>
														</div>
												</span>
										</div>
										<div class="row">
												<div class="col-sm-12">
														<hr class="o-modal-separetor">
												</div>
										</div>
							</div>
							<!--./modal-Body-fixed -->

							<!--.modal-Body-Start-End-Position -->
							<div v-if="modalFilter.position && modalFilter.startTime && modalFilter.endTime" class="add-bulk-form">
                                <div class="c-common-space">
                                    <h2 class="h2">All created calls will have the following values:</h2>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Start Date:</label>
                                            <el-col :span="50">
                                                <el-date-picker
                                                    name="date"
                                                    class="custom_date"
                                                    v-validate="{ required: true}"
                                                    v-model="addCall[0].date"
                                                    type="date"
                                                    :picker-options="pickerOptions"
                                                    :format="getDisplayFormat()"
                                                    value-format="yyyy-MM-dd"
                                                    :placeholder="getDatePlaceholder()">
                                                </el-date-picker>
                                            </el-col>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Start time:</label>
                                            <div class="o-custom-dropdown">
                                                <date-picker name="start" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                                <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">End time</label>
                                            <div class="o-custom-dropdown">
                                                <date-picker name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                                <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Position:</label>
                                            <div class="o-cutsomSelect">
                                                <select v-model="addCall[0].position" class="form-control">
                                                    <option v-for="(position,index) in positions" :key="index" :value="position.id">{{position.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-for="(addCallData, key) in addCall" :key="key" class="added-row">
                                    <div v-if="key != 0" class="add-remove-row-btn text-center">
                                        <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>
                                    </div>
                                    <hr class="o-modal-separetor">
                                    <div class="c-common-space">
                                        <h2 class="h2">Call groups:</h2>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Quantity:</label>
                                                <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Rate:</label>
                                                <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Notes:</label>
                                                <textarea v-model="addCallData.notes" class="form-control" rows="5" placeholder="Type your notes"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="add-remove-row-btn text-center">
                                    <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
                                </div>
							</div>
							<!--./modal-body-Start-End-Position -->

							<!--.modal-Body-Start-End-->
							<div v-if="!modalFilter.position && modalFilter.startTime && modalFilter.endTime" class="add-bulk-form">
								<div class="c-common-space">
									<h2 class="h2">All created calls will have the following values:</h2>
								</div>
								<div class="row">
										<div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Start Date:</label>
                                                <el-col :span="50">
                                                    <el-date-picker
                                                        name="date"
                                                        class="custom_date"
                                                        v-validate="{ required: true}"
                                                        v-model="addCall[0].date"
                                                        type="date"
                                                        :format="getDisplayFormat()"
                                                        :picker-options="pickerOptions"
                                                        value-format="yyyy-MM-dd"
                                                        :placeholder="getDatePlaceholder()">
                                                    </el-date-picker>
                                                </el-col>
                                            </div>
										</div>
										<div class="col-sm-4">
												<div class="form-group">
														<label class="common-label-text common-label-text-block">Start time</label>
														<div class="o-custom-dropdown">
																<date-picker name="start" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
																<span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
														</div>
												</div>
										</div>
										<div class="col-sm-4">
												<div class="form-group">
														<label class="common-label-text common-label-text-block">End time</label>
														<div class="o-custom-dropdown">
																<date-picker name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
																<span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
														</div>
												</div>
										</div>
								</div>
								<div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
									<div v-if="key != 0" class="add-remove-row-btn text-center">
											<a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block">
											<i class="fa fa-minus-circle"></i>
											</a>
									</div>
									<hr class="o-modal-separetor">
									<div class="c-common-space">
											<h2 class="h2">Call groups:</h2>
									</div>
									<div class="row">
											<div class="col-sm-4">
													<div class="form-group">
															<label class="common-label-text common-label-text-block">Position:</label>
															<div class="o-cutsomSelect">
																	<select v-model="addCallData.position" class="form-control">
																		<option v-for="(position,index) in positions" :value="position.id" :key="index">{{position.name}}</option>
																	</select>
															</div>
													</div>
											</div>
											<div class="col-sm-4">
													<div class="form-group">
															<label class="common-label-text common-label-text-block">Quantity:</label>
															<input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
													</div>
											</div>
											<div class="col-sm-4">
														<div class="form-group">
																<label class="common-label-text common-label-text-block">Rate:</label>
																<input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
														</div>
												</div>
											<div class="col-sm-12">
													<div class="form-group">
															<label class="common-label-text common-label-text-block">Notes:</label>
															<textarea v-model="addCallData.notes" class="form-control" rows="5" placeholder="Type your notes"></textarea>
													</div>
											</div>
									</div>
								</div>
                                <div class="add-remove-row-btn text-center">
                                    <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block">
                                    <i class="fa fa-plus-circle"></i>
                                    </a>
                                </div>
							</div>
							<!--./modal-body-Start-End -->

							<!--.modal-Body-Position-->
							<div v-if="modalFilter.position && !modalFilter.startTime && !  modalFilter.endTime" class="add-bulk-form">
								<div class="c-common-space">
									<h2 class="h2">All created calls will have the following values:</h2>
								</div>
								<div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Start Date:</label>
                                            <el-col :span="50">
                                                <el-date-picker
                                                    name="date"
                                                    class="custom_date"
                                                    v-validate="{ required: true}"
                                                    v-model="addCall[0].date"
                                                    type="date"
                                                    :picker-options="pickerOptions"
                                                    :format="getDisplayFormat()"
                                                    value-format="yyyy-MM-dd"
                                                    :placeholder="getDatePlaceholder()">
                                                </el-date-picker>
                                            </el-col>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Position:</label>
                                            <div class="o-cutsomSelect">
                                                <select v-model="addCall[0].position" class="form-control">
                                                    <option v-for="(position,index) in positions" :key="index" :value="position.id">{{position.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
								</div>
								<div v-for="(addCallData,key) in addCall" class="added-row" :key="key">
                                    <div v-if="key != 0" class="add-remove-row-btn text-center">
                                        <a href="javascript: void(0)" @click="removeGroup" class="o-inline-block">
                                                <i class="fa fa-minus-circle"></i>
                                        </a>
                                    </div>
									<hr class="o-modal-separetor">
                                    <div class="c-common-space">
                                        <h2 class="h2">Call groups:</h2>
                                    </div>
                                    <div class="row">                                            
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Start Time:</label>
                                                <div class="o-custom-dropdown">
                                                    <date-picker name="start" v-validate="{required: true}" v-model="addCallData.start" :config="config"></date-picker>
                                                    <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">End Time:</label>
                                                <div class="o-custom-dropdown">
                                                    <date-picker name="end" v-validate="{required: true}" v-model="addCallData.end" :config="config"></date-picker>
                                                    <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Quantity:</label>
                                                <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Rate:</label>
                                                <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Notes:</label>
                                                <textarea class="form-control" v-model="addCallData.notes" rows="5" placeholder="Type your notes"></textarea>
                                            </div>
                                        </div>
                                    </div>
								</div>
								<div @click="addNewGroup()" class="add-remove-row-btn text-center">
                                    <a href="javascript: void(0)" class="o-inline-block">
                                        <i class="fa fa-plus-circle"></i>
                                    </a>
								</div>
							</div>
							<!--./modal-body-Position -->

							<!--.modal-Body-Position-End-->
							<div v-if="modalFilter.position && !modalFilter.startTime &&   modalFilter.endTime" class="add-bulk-form">
								<div class="c-common-space">
									<h2 class="h2">All created calls will have the following values:</h2>
								</div>
								<div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Start Date:</label>
                                                <el-col :span="50">
                                                    <el-date-picker
                                                        name="date"
                                                        class="custom_date"
                                                        v-validate="{ required: true}"
                                                        v-model="addCall[0].date"
                                                        type="date"
                                                        :picker-options="pickerOptions"
                                                        :format="getDisplayFormat()"
                                                        value-format="yyyy-MM-dd"
                                                        :placeholder="getDatePlaceholder()">
                                                    </el-date-picker>
                                                </el-col>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                            <div class="form-group">
                                                    <label class="common-label-text common-label-text-block">Start Time:</label>
                                                    <div class="o-custom-dropdown">
                                                            <date-picker name="start" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                                            <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                                    </div>
                                            </div>
                                    </div>
								</div>
								<div v-for="(addCallData,key) in addCall" class="added-row" :key="key">
										<div v-if="key != 0" class="add-remove-row-btn text-center">
												<a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block">
														<i class="fa fa-minus-circle"></i>
												</a>
										</div>
										<hr class="o-modal-separetor">
										<div class="c-common-space">
												<h2 class="h2">Call groups:</h2>
										</div>
										<div class="row">
												
												<div class="col-sm-6">
														<div class="form-group">
																<label class="common-label-text common-label-text-block">End Time:</label>
																<div class="o-custom-dropdown">
																		<date-picker name="end" v-validate="{required: true}" v-model="addCallData.end" :config="config"></date-picker>
																		<span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
																</div>
																<!--  <el-col :span="50">
																	<el-time-picker
																		name="end"
																		v-validate="{required: true}"
																		v-model="addCallData.end"
																		format="hh:mm a"
																		value-format="HH:mm:ss"
																		:picker-options="{
																			format: 'hh:mm a'
																		}"
																		placeholder="Select time">
																	</el-time-picker>
																</el-col> -->
														</div>
												</div>
												<div class="col-sm-6">
													<div class="form-group">
														<label class="common-label-text common-label-text-block">Position:</label>
														<div class="o-cutsomSelect">
															<select v-model="addCallData.position" class="form-control">
																<option v-for="(position,index) in positions" :key="index" :value="position.id">{{position.name}}</option>
															</select>
														</div>
													</div>
												</div>
												<div class="col-sm-6">
														<div class="form-group">
																<label class="common-label-text common-label-text-block">Quantity:</label>
																<input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
														</div>
												</div>
												<div class="col-sm-6">
																<div class="form-group">
																		<label class="common-label-text common-label-text-block">Rate:</label>
																		<input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
																</div>
														</div>
												<div class="col-sm-12">
														<div class="form-group">
																<label class="common-label-text common-label-text-block">Notes:</label>
																<textarea v-model="addCallData.notes" class="form-control" rows="5" placeholder="Type your notes"></textarea>
														</div>
												</div>
										</div>
								</div>
								<div class="add-remove-row-btn text-center">
                                    <a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block">
                                        <i class="fa fa-plus-circle"></i>
                                    </a>
								</div>
							</div>
							<!--./modal-body-Position-End -->

							<!--.modal-Body-Position-Start-->
							<div v-if="modalFilter.position && modalFilter.startTime &&   !modalFilter.endTime" class="add-bulk-form">
								<div class="c-common-space">
									<h2 class="h2">All created calls will have the following values:</h2>
								</div>
								<div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Start Date</label>
                                            <el-col :span="50">
                                                <el-date-picker
                                                    name="date"
                                                    class="custom_date"
                                                    v-validate="{ required: true}"
                                                    v-model="addCall[0].date"
                                                    type="date"
                                                    :picker-options="pickerOptions"
                                                    :format="getDisplayFormat()"
                                                    value-format="yyyy-MM-dd"
                                                    :placeholder="getDatePlaceholder()">
                                                </el-date-picker>
                                            </el-col>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">End Time:</label>
                                            <div class="o-custom-dropdown">
                                                    <date-picker name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                                    <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                            </div>
                                                <!-- <el-col :span="50">
                                                    <el-time-picker
                                                        name="end"
                                                        v-validate="{required: true}"
                                                        v-model="addCall[0].end"
                                                        format="hh:mm a"
                                                        value-format="HH:mm:ss"
                                                        :picker-options="{
                                                            format: 'hh:mm a'
                                                        }"
                                                        placeholder="Select time">
                                                    </el-time-picker>
                                                </el-col> -->
                                        </div>
                                    </div>
								</div>
								<div v-for="(addCallData,key) in addCall" :key="key" class="added-row">
                                    <div v-if="key != 0" class="add-remove-row-btn text-center">
                                        <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>
                                    </div>
                                    <hr class="o-modal-separetor">
                                    <div class="c-common-space">
                                        <h2 class="h2">Call groups:</h2>
                                    </div>                                    
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Start Time:</label>
                                                <div class="o-custom-dropdown">
                                                    <date-picker name="Start" v-validate="{required: true}" v-model="addCallData.Start" :config="config"></date-picker>
                                                    <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                                </div>
                                                <!-- <el-col :span="50">
                                                    <el-time-picker
                                                        name="Start"
                                                        v-validate="{required: true}"
                                                        v-model="addCallData.Start"
                                                        format="hh:mm a"
                                                        value-format="HH:mm:ss"
                                                        :picker-options="{
                                                            format: 'hh:mm a'
                                                        }"
                                                        placeholder="Select time">
                                                    </el-time-picker>
                                                </el-col> -->
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Position:</label>
                                                <div class="o-cutsomSelect">
                                                    <select v-model="addCallData.position" class="form-control">
                                                        <option v-for="(position,index) in positions" :key="index" :value="position.id">{{position.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Rate:</label>
                                                <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Quantity:</label>
                                                <!-- <div class="o-cutsomSelect">
                                                        <select class="form-control">
                                                                <option>eg: 10</option>
                                                                <option>eg: 11</option>
                                                                <option>eg: 12</option>
                                                                <option>eg: 13</option>
                                                        </select>
                                                </div> -->
                                                <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Notes:</label>
                                                <textarea v-model="addCallData.notes" class="form-control" rows="5" placeholder="Type your notes"></textarea>
                                            </div>
                                        </div>
                                    </div>
								</div>
								<div class="add-remove-row-btn text-center">
									<a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
								</div>
							</div>
							<!--./modal-body-Position-Start -->

							<!--.modal-Body-Start-->
							<div v-if="!modalFilter.position && modalFilter.startTime &&   !modalFilter.endTime" class="add-bulk-form">
								<div class="c-common-space">
									<h2 class="h2">All created calls will have the following values:</h2>
								</div>
								<div class="row">
										<div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Start Date</label>
                                                <el-date-picker
                                                    name="date"
                                                    class="custom_date"
                                                    v-validate="{ required: true}"
                                                    v-model="addCall[0].date"
                                                    type="date"
                                                    :picker-options="pickerOptions"
                                                    :format="getDisplayFormat()"
                                                    value-format="yyyy-MM-dd"
                                                    :placeholder="getDatePlaceholder()">
                                                </el-date-picker>
                                            </div>
										</div>
										<div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">End Time:</label>
                                                <div class="o-custom-dropdown">
                                                    <date-picker name="end" v-validate="{required: true}" v-model="addCall[0].end" :config="config"></date-picker>
                                                        <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                                </div>
                                                    <!-- <el-col :span="50">
                                                        <el-time-picker
                                                            name="end"
                                                            v-validate="{required: true}"
                                                            v-model="addCall[0].end"
                                                            format="hh:mm a"
                                                            value-format="HH:mm:ss"
                                                            :picker-options="{
                                                                format: 'hh:mm a'
                                                            }"
                                                            placeholder="Select time">
                                                        </el-time-picker>
                                                    </el-col> -->
                                            </div>
										</div>
										<div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Position:</label>
                                                <div class="o-cutsomSelect">
                                                    <select v-model="addCall[0].position" class="form-control">
                                                        <option v-for="(position,index) in positions" :key="index" :value="position.id">{{position.name}}</option>
                                                    </select>
                                                </div>
                                            </div>
										</div>
								</div>
								<div v-for="(addCallData,key) in addCall" class="added-row" :key="key">
                                    <div v-if="key != 0" class="add-remove-row-btn text-center">
                                        <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i></a>
                                    </div>
                                    <hr class="o-modal-separetor">
                                    <div class="c-common-space">
                                        <h2 class="h2">Call groups:</h2>
                                    </div>
                                    <div class="row">												
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Quantity:</label>
                                                <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Rate:</label>
                                                <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Start Time:</label>
                                                <div class="o-custom-dropdown">
                                                    <date-picker name="Start" v-validate="{required: true}" v-model="addCallData.start" :config="config"></date-picker>
                                                    <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Notes:</label>
                                                <textarea v-model="addCallData.notes" class="form-control" rows="5" placeholder="Type your notes"></textarea>
                                            </div>
                                        </div>
                                    </div>
								</div>
								<div class="add-remove-row-btn text-center">
									<a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
								</div>
							</div>
							<!--./modal-body-Start -->

							<!--.modal-Body-End-->
							<div v-if="!modalFilter.position && !modalFilter.startTime && modalFilter.endTime" class="add-bulk-form">
								<div class="c-common-space">
									<h2 class="h2">All created calls will have the following values:</h2>
								</div>
								<div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Start Date</label>
                                            <el-date-picker
                                                name="date"
                                                class="custom_date"
                                                v-validate="{ required: true}"
                                                v-model="addCall[0].date"
                                                type="date"
                                                :picker-options="pickerOptions"
                                                :format="getDisplayFormat()"
                                                value-format="yyyy-MM-dd"
                                                :placeholder="getDatePlaceholder()">
                                            </el-date-picker>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Start Time:</label>
                                            <div class="o-custom-dropdown">
                                                <date-picker name="end" v-validate="{required: true}" v-model="addCall[0].start" :config="config"></date-picker>
                                                <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <label class="common-label-text common-label-text-block">Position:</label>
                                            <div class="o-cutsomSelect">
                                                <select v-model="addCall[0].position" class="form-control">
                                                    <option v-for="(position,index) in positions" :key="index" :value="position.id">{{position.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
								</div>
								<div v-for="(addCallData,key) in addCall" class="added-row" :key="key">
                                    <div v-if="key != 0" class="add-remove-row-btn text-center">
                                        <a href="javascript: void(0)" @click="removeGroup(key)" class="o-inline-block"><i class="fa fa-minus-circle"></i>
                                        </a>
                                    </div>
                                    <hr class="o-modal-separetor">
                                    <div class="c-common-space">
                                        <h2 class="h2">Call groups:</h2>
                                    </div>
                                    <div class="row">												
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Quantity:</label>
                                                <!-- <div class="o-cutsomSelect">
                                                        <select class="form-control">
                                                                <option>eg: 10</option>
                                                                <option>eg: 11</option>
                                                                <option>eg: 12</option>
                                                                <option>eg: 13</option>
                                                        </select>
                                                </div> -->
                                                <input type="text" v-model="addCallData.quantity" name="quantity" class="form-control" placeholder="">
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group">
                                                <label class="common-label-text common-label-text-block">Rate:</label>
                                                <input type="text" v-model="addCallData.rate" name="rate" class="form-control" placeholder="">
                                            </div>
                                        </div>
                                            
                                        <div class="col-sm-4">
                                                <div class="form-group">
                                                        <label class="common-label-text common-label-text-block">End Time:</label>
                                                        <div class="o-custom-dropdown">
                                                                <date-picker name="end" v-validate="{required: true}" v-model="addCallData.end" :config="config"></date-picker>
                                                                <span class="o-custom-drop-time"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
                                                        </div>
                                                </div>
                                        </div>
                                        <div class="col-sm-12">
                                                <div class="form-group">
                                                        <label class="common-label-text common-label-text-block">Notes:</label>
                                                        <textarea v-model="addCallData.notes" class="form-control" rows="5" placeholder="Type your notes"></textarea>
                                                </div>
                                        </div>
                                    </div>
								</div>
								<div class="add-remove-row-btn text-center">
									<a href="javascript: void(0)" @click="addNewGroup()" class="o-inline-block"><i class="fa fa-plus-circle"></i></a>
								</div>
							</div>
							<!--./modal-body-End -->
						</div>
						<!-- /.modal-body -->

						<!-- .modal-footer -->
						<div class="modal-footer text-center">
							<ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" @click="closeBulkModal()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="saveBulkCall()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Calls</a>
                                </li>
							</ul>
						</div>
						<!-- /.modal-footer -->

					</div>
					<!-- /.modal-content -->
				</div>
			</div>
		</modal>

		<modal name="clone-job"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div  tabindex="-1" role="dialog">
                <div  role="document">
                        <div class="modal-content o-common-modal-content">
                                <div class="modal-header text-center">
                                        <button @click="closeCloneJob()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <h1 class="modal-title">Clone a Job</h1>
                                </div>
                                <div class="modal-body c-common-box-shadow o-modal-body">
                                        <div class="row">
                                                <div class="col-sm-12">
                                                        <h2 class="h2 text-center">{{job.title}}</h2>
                                                        <div class="row">
                                                                <div class="col-sm-12">
                                                                        <hr class="o-modal-separetor" />
                                                                </div>
                                                        </div>
                                                        <div class="o-accordion-subtext o-rowtable-text form-inline o-rowtable-text">
                                                                <p class="ps2">This tool will create a new job, and duplicate all information and calls from a pre-existing job in the database. If 'copy assignments' is selected, it will also attempt to assign the same employees to the job, and alert you if schedule conflicts are found.</p>
                                                                <p class="ps2">Choose the start date of the new job, and hit 'Clone' to generate the new job.</p>
                                                        </div>
                                                </div>
                                        </div>
                                        <div class="row">
                                                <div class="col-sm-12">
                                                        <hr class="o-modal-separetor" />
                                                </div>
                                        </div>
                                        <div class="row">
                                                <div class="col-sm-6">
                                                        <div class="form-group ">
                                                                <label class="common-label-text">Clone to:</label>
                                                                <label class="common-label-input">
                                                                        <el-date-picker
                                                                                name="date"
                                                                                class="custom_date"
                                                                                v-validate="{ required: true}"
                                                                                v-model="cloneDate"
                                                                                type="date"
                                                                                :format="getDisplayFormat()"
                                                                                value-format="yyyy-MM-dd"
                                                                                :placeholder="getDatePlaceholder()">
                                                                        </el-date-picker>
                                                                </label>
                                                        </div>
                                                </div>
                                                <div class="col-sm-6">
                                                        <div class="form-group ">
                                                                <label class="common-label-text o-auto-width">Copy assignments?</label>
                                                                <div class="checkbox o-custom-radio">
                                                                        <label>
                                                                                <input type="checkbox" id="checkbox" v-model="cloneAssignment">
                                                                                <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                                        </label>
                                                                </div>
                                                        </div>
                                                </div>
                                        </div>
                                </div>

                                <div class="modal-footer text-center">
                                        <ul class="o-filter-area">
                                                <li>
                                                        <a href="javascript: void(0)" @click="closeCloneJob()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                                </li>
                                                <li>
                                                        <a href="javascript: void(0)" @click="saveCloneJob" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-files-o" aria-hidden="true"></i> Clone Job</a>
                                                </li>
                                        </ul>
                                </div>

                        </div>

                </div>
            </div>
		</modal>

		<modal name="edit-comment-request-modal" :clickToClose="false" height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
		    <div tabindex="-1" role="dialog">
		        <div role="document">
		            <div class="modal-content o-common-modal-content">
		                <div class="modal-header u-no-border text-center modal-header--heading">
		                    <button @click="closeEditCommentRequesstModal()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
		                    <h1 class="modal-title">Edit {{ edit_request_comment_title }} </h1>
		                </div>
		                <div class="modal-body c-common-box-shadow o-modal-body">

		                    <div class="row">
		                        <div class="col-sm-12">
		                            <div class="form-group">
		                                <label class="common-input--fullwidth" v-if="edit_request_comment_title == 'Employer Request'">
		                                    <vue-editor id="editor1" class="c-common-box-shadow c-radius3" v-model="edit_request_comment.employer_requests" style="height: 220px;"></vue-editor>
		                                    <span v-show="errors.has('note') && this.validation_err!=0" class="err-msg">{{ errors.first('note') }}</span>
		                                </label>
		                                <label class="common-input--fullwidth" v-else>
		                                    <vue-editor id="editor1" class="c-common-box-shadow c-radius3" v-model="edit_request_comment.calender_comment" style="height: 220px;"></vue-editor>
		                                    <span v-show="errors.has('note') && this.validation_err!=0" class="err-msg">{{ errors.first('note') }}</span>
		                                </label>
		                            </div>
		                        </div>

		                    </div>
		                </div>

		                <div class="modal-footer text-center">
		                    <ul class="o-filter-area">
		                        <li>
		                            <a href="javascript: void(0)" @click="closeEditCommentRequesstModal()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
		                        </li>
		                        <li>
		                            <a href="javascript: void(0)" @click="modalEditCommentRequestSubmit()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
		                        </li>
		                    </ul>
		                </div>

		            </div>
		            <!-- /.modal-content -->
		        </div>
		        <!-- /.modal-dialog -->
		    </div>
		</modal>
	</div>
    <div v-else-if="!isEmployeeAllowed">
        <NotAllowed />
    </div>
</template>
<script>

	import { VueEditor } from 'vue2-editor';
    import { mapGetters, mapActions} from 'vuex';
    import NotAllowed from '@/components/NotAllowed';
    import service from '../../services.js';
    import { global } from '../../global.js';
	import dateTimeConvert from '../../timeConvert&Compare';
    import 'viewerjs/dist/viewer.css';
    // import Viewer from 'v-viewer';
    // import Vue from 'vue';

    // import { Viewer as ReportViewer} from '@grapecity/activereports-vue';
    import "@grapecity/activereports/styles/ar-js-ui.css";
    import "@grapecity/activereports/styles/ar-js-viewer.css";

    // import {PdfExport}  from "@grapecity/activereports/core";

    // const pdfExportSettings = {
    //     title: "Test document",
    //     author: "GrapeCity",
    //     keywords: "export, report",
    //     subject: "Report",
    //     pdfVersion: "1.4"
    // };

    // import {Core} from "@grapecity/activereports"; 
    // const report = new Core.PageReport();
    // report.load("/reports/text-only.rdlx-json");
    // const doc = report.run();
    // const result = PdfExport.exportDocument(doc, pdfExportSettings);
    

    // Core.setLicenseKey("reports.callsteward.net|reports.callsteward.ca|reports.callsteward.com,691811311633861#B0sUi8g7Ri9UbztiNThnSCFXM7smdP3SNN5ERxBVZzB5T99mR986aqFWb7clSLJHZjR4UIZGVEh4aNd4MpRESLhmUBZHRuFWSy56L8BXaURjMtNDV5MkVpZ6aLZmZ88WZyEjY4YDRKxGUYZmapl5V6QjUmVHRqJTTG9WQzUTapJEezAVND5GbCRVYX3ibjRUTVJXeK3EW6llN8t4bppUN9MVMidDOxRzdnN5awFkRYtWQINkYO3Cb7skc6VjRrB5bnticDF7chtkeH3iNLdzdoZ7Rp5mMmBXaSNlQ8IVb8hjeJNkUN5mcys4RWZzR79mRDNzUz5USaBld03yNIFFa8o7KzgmeHl7QrNUQWVlI0IyUiwiI8kDO4AjRERjI0ICSiwiMzAzM6QTM4AjM0IicfJye&Qf35VfikkVBVkI0IyQiwiIyYFITpEdy3GclJVZ6lGdjFkI0IiTis7W0ICZyBlIsIiMwgDNwEDI5IjNwEjMwIjI0ICdyNkIsISbvNmLkJXY7VGdzxGbhNmLzRncvBXZyxSYj9CZyF6dlR7csxWYj9yc4J7bwVmcsQXZu9CZyF6dlR7csxWYj9yc4J7bwVmciojIz5GRiwiIkJXY7VGdTBCbsF6QiojIh94QiwiIxYDOzMjNxEzMxEDOxkjNiojIklkIs4XXbpjInxmZiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34zZwl6bOdFZXtkeBhza99USa94ZBNXe6p6MSZWcxoGVyY7UoRGeopWcrpXW4UmV5ZEOWtSRv8WYytEVMVDMwI5MRR6cYxkUwu5vz");

    export default {
        data() {
            const dataProps = {
                isEmployeeAllowed: true,
                isSteward: 0,
				loading: false,
				modalLoading: false,
                deny_steward_access: 0,
                jobStatus:'Draft',
            	modalDataLoad:true,
                pictureExtension: false,
                jobStart: null,
                jobEnd: null,
                pub: true,
                new_files: [],
                selected: '',
                job: null,
                calls:null,
                count: 0,
                uploaded_files: [],
                employer_users:[],
                validation_err: 0,
                notes: [],
				employer_request: "",
				calender_comments: "",
                editNote: {
                    content: '',
                    noteable_id: '',
                    noteable_type: '',
                    uploader: '',
                    noteID: '',
                },
                addEmployer: {
                    note: '',
                },
                
				edit_request_comment: {
				    employer_requests: "",
                    calender_comment: "",
				},
                edit_request_comment_title: "",
                employer_request_flag: "",
                employer_requests_signin: "",
                calender_comment_flag: "",
                attachmentList: [],
                job_delete_notify:0,
                venues: [],
                employers: [],
                employees: [],
                payrolls: [],
                stewards: [],
                dispatchedList: [],
                createdByList:[],
                config_arr: [],
                addJob: {
                    title: '',
                    hiring_organization_id: '',
                    payroll_id: '',
                    employer_contact: '',
                    rate_id: '',
                    link_color: '',
                    employee_id: '',
                    created_by: '',
                    dispatched_by: '',
                    start: '',
                    end: '',
                    venue_id: '',
                    location_details: '',
                    employer_requests: '',
                    employer_requests_private: '',
                    employer_requests_signin: '',
                    comment: '',
                    comment_private: '',
                    hts_flag:0,
                    steward_access_flag:0,
                    skill_id1: '',
                    skill_id2: '',
                    skill_id3: ''
                },
                config: {
                    format: 'h:mm A',
                    useCurrent: false,
                    showClear: false,
                    showClose: false,
                    widgetPositioning: {
                        //vertical: 'top',
                        horizontal: 'right'
                    },
                    parseInputDate: (inputDate) => {
                        if (typeof inputDate === 'string') {
                        // Handle case where user inputs 3 or 4 digits (e.g., 800 or 1230)
                        const match = inputDate.match(/^(\d{1,2})(\d{2})?$/);

                        if (match) {
                            let hours = parseInt(match[1], 10);
                            let minutes = match[2] ? parseInt(match[2], 10) : 0;

                            // Adjust hours if necessary for AM/PM logic (optional)
                            // if (hours > 12) hours -= 12;

                            // Return a Moment.js object
                            return moment({ hour: hours, minute: minutes });
                        }
                        }

                        // Default fallback to create a Moment object
                        return moment(inputDate, 'hh:mm A');
                    }
                },

                positions: [],

                addCall: [{
                    date: '',
                    start: '',
                    end: '',
                    quantity: '',
                    rate: '',
                    position: '',
                    notes: '',
                    // cookieRole: ''
                }],
                cloneDate: '',
                cloneAssignment: true,
                modalFilter: {
                    position: true,
                    startTime: true,
                    endTime: true
                },
                pickerOptions1: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDatesCallPicker().jobStart);
                    }
                },
                pickerOptions: {
                    disabledDate(time) {
                        return (time.getTime() < dataProps.getDatesCallPicker().jobStart || time.getTime() > dataProps.getDatesCallPicker().jobEnd);
                    }
                },
                selectConfig:{
                    days:[0, 1, 2, 3, 4, 5],
                    hours:[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
                    mins:[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]
                },
                globalTimeOut:{
                    days:0,
                    hours:0,
                    mins:0
                },
                jobTimeOut:{
                    days:0,
                    hours:0,
                    mins:0
                },
                getDatesForJobPicker: function() {
                    return {
                        jobStart: new Date(dataProps.addJob.start).setDate(new Date(dataProps.addJob.start).getDate() - 1)
                    };
                },
                getDatesCallPicker: function() {
                    return {
                        jobStart: dataProps.jobStart,
                        jobEnd: dataProps.jobEnd
                    };
				},
				full_address_map:"Call Steward",

				// ===================
				// startLocation: {lat:22.5770293, lng:88.4888099},
				
				// coordinates: [],
				// infoPosition: null,
				// infoContent: null,
				// infoOpened: false,
				// infoCurrentKey: null,
				// infoOptions: {
				// 	pixelOffset: {
				// 		width: 0,
				// 		height: -35
				// 	}
				// },
                global_skills: null,
                clientData: null,
                userDateFormat:null,
                userTimeFormat:null,
                estimate_payroll_button: 0,
                editJobFormData: null,
                editJobAction: '',
                editJobAddNote: {
                    note: '',
                },
                selectedSortType: '',
                rates: [],
                rate_table_name: '',
                rdlxWishlistUrl: null,
                getBaseURL: ''
            }
            return dataProps;
        },

        components: {
            VueEditor,
            NotAllowed
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userId: 'userID',
                userName: 'userName',
                userFullName: 'userFullName',
                employeeId: 'employeeId',
                getSignInSheetConfig: 'getSignInSheetConfig',
                userRoleSlug:'userRoleSlug'
			})
        },
        methods: {
            checkSteward(){
                service.get('employee/'+this.employeeId +'/checkSkill', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    this.isSteward=res.data.result;
                    // console.log(res);
                    if(this.isSteward != 1 && this.userRoleSlug=='employee')
                        this.$router.push({
                            path: `/`
                        });
                }).catch((err) => {
                    this.$Progress.fail();
                });
            },
            checkArjsArchive() {
                console.log("Check Archive method");
            },
            async getWishlistSummaryReportTemplateUrl(){
                await service.get('client/getEmployeeWishlistSummaryReportUrl', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                   if(res.data.result) {
                    this.rdlxWishlistUrl = res.data&&res.data.result&&res.data.result!=''?res.data.result:null;
                    // this.loadWishlistSummaryReportJson()
                   }
                }).catch((err) => {
                    console.log(err);
                });
            },
            loadWishlistSummaryReportJson() {
                this.loading=true;
                service.get('client/employeeWishlistSummaryJsonPayload/'+atob(this.$route.params.id), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then(async(res) => {
                    // console.log(res.data);
                    await this.getWishlistSummaryReportTemplateUrl();
                    this.loading=false;
                    let data_source = res.data.result&&res.data.result!=''?res.data.result:null;
                    if(this.rdlxWishlistUrl && data_source) {
                        let redirectUrl = dateTimeConvert.getEmployeeReportUrl('jobReports/', this.rdlxWishlistUrl, data_source);
                        window.open(redirectUrl, "_blank");  
                    }else {
                        this.$notify({
                            title: 'Error',
                            message: 'Something went wrong!',
                            type: 'error'
                        });
                    }
                }).catch((err) => {
                    this.loading=false;
                    console.log(err);
                });
            },
            addVenueAddress() {
                this.$router.push({
                    'path': '/addVenue'
                });
            },
            getUserDateTimeFormat(jobDateTime) {
                return dateTimeConvert.getUserDateTime(jobDateTime,this.userDateFormat,this.userTimeFormat);
            },
            blur(event) {
                if ($(event.target).val() === "") {
                    $(event.target).siblings('.form-label').addClass('js-label-transition');
                    this.validation_err = 1;
                } else {
                    $(event.target).siblings('.form-label').removeClass('js-label-transition');
                    this.validation_err = 0;
                }
            },

            async getClientData() {
                // console.log(this.userRole);   
                // console.log(this.userRoleSlug);   
                await service.get('client/' + this.userClientID, {
                'Authorization': this.userToken
                })
                .then((res) => {
                    this.clientData = res.data.result;
                    // console.log(this.clientData)
                    this.global_skills = this.clientData.global_skills;
                    this.estimate_payroll_button = this.clientData.estimate_payroll_button;
                    // console.log(this.global_skills)
                }).catch((err) => {
                    console.log(err);
                });
            },

			// getPosition: function(marker) {
			// 	return {
			// 		lat: parseFloat(marker.lat),
			// 		lng: parseFloat(marker.lng)
			// 	}
			// },
			// toggleInfo: function(marker, key) {
			// 	this.infoPosition = this.getPosition(marker);
			// 	this.infoContent = marker.full_name;
			// 	if (this.infoCurrentKey == key) {
			// 		this.infoOpened = !this.infoOpened;
			// 	} else {
			// 		this.infoOpened = true;
			// 		this.infoCurrentKey = key;
			// 	}
			// },

			// ===========================

			changeJobDeleteNotify(){
				// if(this.job_delete_notify){
				// 	console.log(this.job_delete_notify);
				// }else{
					// console.log(this.$route.params.id);
				// }
				service.post('job/disableDeleteNotify', {
                    'job_id': atob(this.$route.params.id),
                    'disable_notify': this.job_delete_notify
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    // console.log('success');

                }).catch((err) => {
                    console.log(err);
                });
			},

            changeDenyStewardAccess(){
                this.editJobAction='deny-steward-access';
                // this.openEditJobAddNoteDialog();
                this.$modal.show("edit-job-add-note");
                this.editJobAddNote.note = 'Deny Steward Access';
			},

            async switchStewardAccess(jobNote) {
                let jobID = atob(this.$route.params.id);
                let steward_access_flag = this.deny_steward_access ? 0 : 1;

                jobNote.steward_access_flag = steward_access_flag;
                
				await service.put('job/'+jobID+'/saveStewardAccessFlag', jobNote, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then(async (res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Steward Access Changed.',
                        type: 'success'
                    });
                    this.$modal.hide("edit-job-add-note");
                    await this.jobDetails();
                }).catch((err) => {
                    console.log(err);
                    this.$notify({
                        title: 'Error',
                        message: 'Something went wrong',
                        type: 'error'
                    });
                });
            },

			getMapUrl(){
				return dateTimeConvert.getMapUrl(this.full_address_map);
			},

			getDisplayFormat(){
                var format = dateTimeConvert.getDateInputFormat();
                // console.log(format);
                return format?format:'MM/dd/yyyy';
            },

            getDatePlaceholder(){
                return dateTimeConvert.getDatePlaceHolder();
            },

        	checkDeleteAccess(){
				if(this.calls && this.calls.length==0)
					return true;
				return false;
        	},

        	setGlobalTimeout(time){
                var hours=time.split(':')[0];
                var minutes= time.split(':')[1];

                this.globalTimeOut.days=Math.floor(hours/24);
                this.globalTimeOut.hours=Math.floor(hours%24);
                this.globalTimeOut.mins=Math.floor(minutes);
            },

            setJobTimeout(time){
                var hours=time.split(':')[0];
                var minutes= time.split(':')[1];
                //console.log(hours/24);
                this.jobTimeOut.days=Math.floor(hours/24);
                this.jobTimeOut.hours=Math.floor(hours%24);
                this.jobTimeOut.mins=Math.floor(minutes);
            },

            getJobTimeOut(){
                var hours = (this.jobTimeOut.days*24)+this.jobTimeOut.hours;
                var mins =this.jobTimeOut.mins;
                return Math.round(hours)+':'+Math.round(mins);
            },

            onChangeJobTimeOut(){
                let timeOut=this.getJobTimeOut();
                service.post('job/updatejobTimeOut', {
                    'job_id': atob(this.$route.params.id),
                    'timeout':timeOut
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                })
                .then((res) => {
                    console.log('success');

                }).catch((err) => {
                    console.log(err);
                });
            },

            changeShareAccess(id, value){
            	service.get('attachment/'+id+'/updateAttachment', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'shareable': value
                }).then((res) => {
                	this.$notify({
                        title: this.$t('success'),
                        message: 'Access Changed.',
                        type: 'success'
                    });
                }).catch((err) => {
                    console.log(err);
                });
            },

        	copyDocumentLink(link){
        		// console.log(link);
        		var textarea = document.createElement("textarea");
		        textarea.textContent = link;
		        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
		        document.body.appendChild(textarea);
		        textarea.select();
		        try {
		        	console.log(textarea);
		            document.execCommand("copy");  // Security exception may be thrown by some browsers.
		            this.$notify({
                        title: this.$t('success'),
                        message: 'link copied to clipboard.',
                        type: 'success'
                    });
                    setTimeout(()=>{ 
                    	// window.location.href=link;
                    	window.open(link, '_blank');
                	}, 2000);
                    
		        } catch (ex) {
		            console.warn("Copy to clipboard failed.", ex);
		            return false;
		        } finally {
		            document.body.removeChild(textarea);
		        }
        	},

        	addCallPower(){
        		if(this.job.employee.id==this.employeeId){
        			return true;
        		}else{
        			return false;
        		}
        	},

        	decodeFileId(id){
                return btoa(id);
            },

            closeCloneJob() {
                this.$modal.hide("clone-job");
            },

            cloneJob(job) {
                this.$modal.show("clone-job");
            },

            saveCloneJob() {
                this.editJobAction = 'clone-job';
                this.editJobAddNote.note = 'Clone Job';
                this.$modal.hide("clone-job");
                this.$modal.show("edit-job-add-note");                
            },

            saveCloneJobRequest(jobNote) {
                this.modalLoading = true;
                this.$forceUpdate();
                // let fromData = {
                jobNote.client_id = this.userClientID;
                jobNote.start = this.cloneDate + " " + Date().slice(16, 24);
                jobNote.assign = (this.cloneAssignment) ? 1 : 0;
                jobNote.user_id = this.userId;
                // };
                service.post('job/' + this.job.id + '/clone', jobNote, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).
                then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: res.data.result,
                        type: 'success'
                    });
                    this.modalLoading=false;
                    //console.log(res.data.result);
                    // this.$message({
                    //     type: 'success',
                    //     message: res.data.result,
                    // });
                    this.jobDetails();
                    this.$modal.hide("edit-job-add-note");
                }).catch((err) => {
                    this.modalLoading=false;
                    console.log(err);
                });
            },

        	show(index, listid, fileName, path) {
                if (listid != undefined) {
                    var extension = fileName.split('.').pop();
                     if (['jpg', 'jpeg', 'ico', 'png', 'svg', 'tif', 'tiff', 'gif', 'bmp', 'webp', 'aac', 'mid', 'midi', 'mp3', 'oga', 'opus', 'wav', 'weba', '3gp', '3g2', 'avi', 'mp4', 'mpeg', 'ogv', 'webm'].indexOf(extension) > -1) {
                        this.$el.querySelector('.images' + index + listid).$viewer.show();
                    } else if (['xls', 'csv', 'xlsx', 'xlr', 'ods', 'doc', 'docx', 'odt', 'rtf', 'tex', 'wps', 'wks', 'odp', 'ppt', 'pptx'].indexOf(extension) > -1) {
                        window.open('https://view.officeapps.live.com/op/view.aspx?src=' + path);
                        // window.open('https://view.officeapps.live.com/op/view.aspx?src=' + this.$el.querySelector('.files' + index + listid).getAttribute('href'));
                    } else if (['pdf', 'text', 'txt'].indexOf(extension) > -1) {
                        window.open('https://docs.google.com/viewer?url=' + path);
                        // window.open('https://docs.google.com/viewer?url=' + this.$el.querySelector('.files' + index + listid).getAttribute('href'));
                    } else {
                        window.open(this.$el.querySelector('.files' + index + listid).getAttribute('href'));
                    }
                }
            },

        	snippet(value) {
                if (value.length > 25)
                    return value.slice(0, 25) + '  ...';
                else
                    return value;
            },

            getDate(str) {
                return dateTimeConvert.globalDate(str,this.userDateFormat);
                //var date = str.split(" ");
                //return date[0];
            },

            getTime(dateTime) {
                return dateTimeConvert.globalTime(dateTime,this.userTimeFormat);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },

            getDateUtc(str) {
                return dateTimeConvert.dateFromUtc(str);
                //var date = str.split(" ");
                //return date[0];
            },

            getTimeUtc(dateTime) {
                return dateTimeConvert.timeFromUtc(dateTime);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            
            updateEndDate() {
                //this.addJob.end = this.addJob.start;
                //console.log("Start",this.addJob);
            },

            getColor(color) {
                var value = color.substr(1);
                return value;
            },

            getNoteAuthor(note) {
                var getAuthor = JSON.parse(note.activity);
                if (getAuthor&&getAuthor.uploader_id == this.userId) {
                    return "Me";
                } else {
                    return getAuthor.uploaded_by;
                }
            },

            deleteNote(id){
                this.$confirm('Are you sure you would like to delete this notes? ', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.del('note/'+ id, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'uploader':this.userId
                    }).then(async(res) => {
                        // console.log(res.data.status_code);
                        if(res.data.status_code==1){
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Note deleted Successfully.',
                                type: 'success'
                            });
                            await this.jobDetails();
                            // this.onUpdateOrAdd();
                        }else{
                            this.$notify({
                                title: this.$t('error'),
                                message: res.data.status_message,
                                type: 'error'
                            });
                        }
                    }).catch((err)=>{
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            editSingleNotes(note) {
                this.$modal.show("edit-single-notes");
                this.addEmployer.note = note.content;
                var noteActivity = JSON.parse(note.activity);

                this.editNote.noteID = note.id;
                this.editNote.content = this.addEmployer.note;
                this.editNote.noteable_id = note.noteable_id;
                this.editNote.noteable_type = note.noteable_type;
                this.editNote.uploader = this.userId;
            },

            closeEditSingleNotes() {
                this.$modal.hide("edit-single-notes");
            },

            editNewNote() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.validation_err = 0;
                        this.editNote.content = this.addEmployer.note;
                        service.put('note/' + this.editNote.noteID, this.editNote, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        }).
                        then((res) => {
                            setTimeout(() => {
                                this.$modal.hide('edit-single-notes');
                            }, 500);
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Note Updated Successfully.',
                                type: 'success'
                            });
                            this.jobDetails();
                        }).catch((err) => {
                            
                            this.$Progress.finish();
                            
                        });
                    } else {
                        this.validation_err = 1;
                    }
                });
            },

            addNewNote() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        var activityID = {
                            "uploader_id": this.userId,
                            "uploaded_by": this.userFullName,
                        }
                        activityID = JSON.stringify(activityID);
                        var jobNote = {
                            noteable_id: this.job.id,
                            noteable_type: 'job',
                            activity: activityID,
                            content: this.addEmployer.note,
                        };
                       
                        service.post('note', jobNote, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        }).
                        then((res) => {
                            setTimeout(() => {
                                this.$modal.hide('add-single-notes');
                            }, 500);
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Job Note Added Successfully.',
                                type: 'success'
                            });
                            
                            this.jobDetails();
                        }).catch((err) => {
                            
                            this.$Progress.finish();
                            
                        });
                        
                    } else {
                        this.validation_err = 1;
                    }
                });
            },

            editJobAddNewNote() {
                        //console.log("success");
                var activityID = {
                    "uploader_id": this.userId,
                    "uploaded_by": this.userFullName,
                }
                activityID = JSON.stringify(activityID);
                var jobNote = {
                    noteable_id: this.job.id,
                    noteable_type: 'job',
                    activity: activityID,
                    content: this.editJobAddNote.note,
                };

                let type = this.editJobAction;

                switch(type){
                    case 'edit-job': 
                        this.editJobRequest(jobNote);
                        break;
                    case 'deny-steward-access':
                        this.switchStewardAccess(jobNote);
                        break;
                    case 'comments':
                        this.updateCalendarCommentEmployerRequest(jobNote);
                        break;

                    case 'clone-job':
                        this.saveCloneJobRequest(jobNote);
                        break;
                    case 'publish':
                        this.switchPublishAddNote(jobNote);
                        break;
                    default:
                        console.log("Default Add Note");
                }
            },

            employeeDownload() {
                service.get('employee/employeeExport', {
                    'Authorization': this.userToken,
                    'jobId': atob(this.$route.params.id),
                    'ClientId': this.userClientID
                }).
                then((res) => {
                    this.JSONToCSVConvertor(res.data.result, "Employee details", true);

                }).catch((err) => {
                    console.log(err);
                });
            },

            JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

                var CSV = '';
                //Set Report title in first row or line

                CSV += ReportTitle + '\r\n\n';

                //This condition will generate the Label/Header
                if (ShowLabel) {
                    var row = "";

                    //This loop will extract the label from 1st index of on array
                    for (var index in arrData[0]) {

                        //Now convert each value to string and comma-seprated
                        row += index + ',';
                    }

                    row = row.slice(0, -1);

                    //append Label row with line break
                    CSV += row + '\r\n';
                }

                //1st loop is to extract each row
                for (var i = 0; i < arrData.length; i++) {
                    var row = "";

                    //2nd loop will extract each column and convert it in string comma-seprated
                    for (var index in arrData[i]) {
                        row += '"' + arrData[i][index] + '",';
                    }

                    row.slice(0, row.length - 1);

                    //add a line break after each row
                    CSV += row + '\r\n';
                }

                if (CSV == '') {
                    alert("Invalid data");
                    return;
                }

                //Generate a file name
                var fileName = "Job_";
                //this will remove the blank-spaces from the title and replace it with an underscore
                fileName += ReportTitle.replace(/ /g, "_");

                //Initialize file format you want csv or xls
                var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

                // Now the little tricky part.
                // you can use either>> window.open(uri);
                // but this will not work in some browsers
                // or you will not get the correct file extension

                //this trick will generate a temp <a /> tag
                var link = document.createElement("a");
                link.href = uri;

                //set the visibility hidden so it will not effect on your web-layout
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";

                //this part will append the anchor tag and remove it after automatic click
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },

            addSingleNotes() {
                this.$modal.show("add-single-notes");
                this.addEmployer.note = '';
            },

            openEditJobAddNoteDialog() {
                this.$modal.show("edit-job-add-note");
                this.editJobAddNote.note = '';
            },

            closeSingleNotes() {
                this.$modal.hide("add-single-notes");
            },

            closeEditJobNote() {
                this.$modal.hide("edit-job-add-note");
            },
            
            async jobDetails() {
                this.job = null;
                this.$forceUpdate();
                this.$Progress.start();
                this.loading = true;
                await service.get('job/' + atob(this.$route.params.id), {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    //console.log("Job details", res);
                    this.$store.dispatch('setJob', res.data.result);
                    this.job = res.data.result;
                    this.$forceUpdate();
                    this.calls=this.job.calls;
                    this.jobStatus=this.job.status.name;
                    this.notes = res.data.result.notes;
					this.employer_request = res.data.result.employer_requests;
					this.calender_comments = res.data.result.comment;
                    this.attachmentList = res.data.result.attachments;

                    this.jobStart = new Date(this.job.start);
                    this.jobStart.setDate(this.jobStart.getDate() - 1);
                    this.jobEnd = new Date(this.job.end);
                    this.setJobTimeout(this.job.timeout);
                    this.employer_request_flag = this.job.employer_requests_private;
                    this.employer_requests_signin = this.job.employer_requests_signin;
                    this.calender_comment_flag = this.job.comment_flag;
                    this.$Progress.finish();
					let venue =this.job.venue;
					this.job_delete_notify = this.job.disable_notify;
					if(venue && venue.addresses && venue.addresses.length){
						this.full_address_map =venue.name + ", " +venue.addresses[0].address + ", " +venue.addresses[0].municipality +", "+venue.addresses[0].postcode +", " +venue.addresses[0].state_province +", "+ venue.addresses[0].country;
					}
                    // console.log(this.job.steward_access_flag);
                    this.deny_steward_access = this.job.steward_access_flag ? 0 : 1;
                    this.addJob.rate_id = this.job.rate_id;
                    if(this.addJob.rate_id&&this.addJob.rate_id!=""){
                        this.getRateName(this.addJob.rate_id);
                    }
                    // this.$forceUpdate();
                }).catch((err) => {
                    if(err.response&&err.response.status&&err.response.status==403) {
                        this.isEmployeeAllowed = false;
                        this.$notify({
                            title: 'Important message',
                            message: "You don't have Access!",
                            type: 'error'
                        });
                        this.$router.push({path: '/schedule/', params: {empId: btoa(this.employeeId)}});
                    }
                });
                this.loading = false;
            },

            goToAssign() {
            	this.$store.dispatch('setSelectedCallList', 'bulk');
                this.$router.push({
                    path: `/viewCalls/`+ this.$route.params.id
                });
            },

            goSignInSheet() {
                this.$router.push({
                    path: `/jobSheet/`+ this.$route.params.id
                    // path: `/signinsheet/`+ this.$route.params.id
                });
			},

			gcsSignInSheet(){
				this.loading = true;
				 service.get('call/signInSheetJsonPayload',{
					'Authorization': this.userToken,
					'cs3-context-role': this.userRole,
					'cs3-context-clientId': this.userClientID,
					'job-id': atob(this.$route.params.id),
				}).then(async res =>{
					// console.log(res.data.result);
                    let data_source = res.data.result;
					this.loading = false;
					let redirectUrl = dateTimeConvert.getSignInSheetUrl('jobReports/',data_source);
                    console.log(redirectUrl);
					window.open(redirectUrl, "_blank");  					
				}).catch(err =>{
					this.loading = false;
					console.log(err);
				})
			},

            goToCalls() {
            	this.$store.dispatch('setSelectedCallList', 'bulk');
                this.$router.push({
                    path: `/viewCalls/` + this.$route.params.id
                });
            },

            goToPhoneSheet() {
                this.$router.push({
                    path: `/phoneSheet/` + this.$route.params.id
                });
            },

            gotoJobAttendance() {
                this.$router.push({
                    path: `/jobAttendance/`+this.$route.params.id
                });
            },

            getDate(date) {
                return dateTimeConvert.globalDate(date,this.userDateFormat);
            },

            // getRefs(venue) {
			// 	if(venue && venue.addresses && venue.addresses.length){
			// 		let self=this;
			// 		var geocoder = new google.maps.Geocoder();
			// 		// var address = "Mani Casadona, newtown, kolkata";
			// 		var address =venue.name + ", " +venue.addresses[0].address + ", " +venue.addresses[0].municipality +", "+venue.addresses[0].postcode +", " +venue.addresses[0].state_province +", "+ venue.addresses[0].country;
			// 		geocoder.geocode( { 'address': address}, function(results, status) {
			// 			if (status == google.maps.GeocoderStatus.OK) {
			// 				var latitude = results[0].geometry.location.lat();
			// 				var longitude = results[0].geometry.location.lng();
			// 				self.startLocation = {lat: latitude, lng: longitude};
			// 				self.coordinates.push({
			// 					full_name: address,
			// 					lat: latitude,
			// 					lng: longitude
			// 				});

			// 				console.log('coordinates',self.coordinates);

			// 			} 
			// 		});
			// 	}
            // },

            publishedJob() {
                // this.$modal.show('edit-job-add-modal');
                this.editJobAction = 'publish';
                // this.openEditJobAddNoteDialog();  
                this.$modal.show("edit-job-add-note");
                this.editJobAddNote.note = this.jobStatus == "Published"?'Publish Job':'Unpublish Job';         
            },

            async switchPublishAddNote(jobNote) {
                this.$Progress.start();
                jobNote.hiring_organization = ''; 
                jobNote.venue = '';

                if (this.jobStatus == "Published") {
                    await service.put('job/' + this.job.id + '/publish', jobNote, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then(async(res) => {
                        this.$modal.hide('edit-job-add-note');
                        this.$notify.success({
                            message: res.data.status_message,
                            title: 'Success'
                        })
                        this.$Progress.finish();
                        //console.log(" Published success=>",job.status.name)
                		this.job.status.name="Published";
                        await this.jobDetails();
                    }).catch((err) => {
                        console.log(err);
                    });
                } else {
                    await service.put('job/' + this.job.id + '/unpublish', jobNote, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then(async(res) => {
                        this.$modal.hide('edit-job-add-note');
                        this.$notify.success({
                            message: res.data.status_message,
                            title: 'Success'
                        })
                        this.$Progress.finish();
                        await this.jobDetails();
                    }).catch((err) => {
                        console.log(err);
                    });
                }

            },


            toggleHeader(id) {
                if ($('#' + id).children().hasClass("fa-plus-circle")) {
                    $('#' + id).parent().addClass('js-active-togg');
                    $('#' + id).children().removeClass('fa-plus-circle').addClass('fa-minus-circle');
                    $('#' + id).siblings(".o-toggle-content").children(".js-note-txt-expand").addClass("js-togg-expand-height");
                } else {
                    $('#' + id).parent().removeClass('js-active-togg');
                    $('#' + id).children().removeClass('fa-minus-circle').addClass('fa-plus-circle');
                    $('#' + id).siblings(".o-toggle-content").find(".js-note-txt-expand").removeClass("js-togg-expand-height");
                }
            },

            addFileToList(e) {
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                      var fileName = input.files[0].name;
                    var Extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
                    var allowedFiles = ['wks', 'wps', 'tex', 'rtf', 'csv', 'xlr', 'doc', 'docx', 'odp', 'ods', 'odt', 'pdf', 'ppt', 'pptx', 'xls', 'xlsx', 'bmp', 'gif', 'ico', 'jpeg', 'jpg', 'png', 'svg', 'tif', 'tiff', 'webp', 'aac', 'mid', 'midi', 'mp3', 'oga', 'opus', 'wav', 'weba', '3gp', '3g2', 'avi', 'mp4', 'mpeg', 'ogv', 'ts', 'webm', 'txt', 'text'];

                    if (!allowedFiles.includes(Extension)) {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Invalid File.'
                        });
                        return false;
                    } else {
                            var reader = new FileReader();
                            if (input.files[0].size < 2000000) {
                                reader.onload = (e) => {
                                    img = e.target.result;

                                    var type = input.files[0].type.split("/");
                                    this.new_files.push({
                                        'img': img,
                                        'name': input.files[0].name,
                                        'status': true,
                                        'uploading': false,
                                        'uploaded': false,
                                        'path': '',
                                        'type': type[0],
                                        'progress': 0,
                                        'label': 'Report',
                                        'fileExtension': this.setPicture(type[0])
                                    });
                                }
                                reader.readAsDataURL(input.files[0]);
                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Document size should be less than 2 MB'
                                });
                            }
                    }

                }
            },

            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },

            uploadImage() {
                //console.log(this.new_files);
                for (var i = 0; i < this.new_files.length; i++) {

                    if (this.new_files[i].status == true && this.new_files[i].uploaded == false) {
                        this.new_files[i].progress = 20;
                        //console.log("UPLOAD", this.new_files[i]);
                        this.uploadService(this.new_files[i]).then((path) => {
                            //console.log(path);
                        }).catch((err) => {
                            console.log(err);
                        });

                    }
                    //console.log(this.new_files);
                }
            },

            uploadService(img) {
                img.progress = 50;
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment/uploadSingleFile', {
                            'image_file': img.img,
                            'file_name': img.name

                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            //console.log(res);
                            resolve(res);
                            img.path = res.data.result.path;
                            img.progress = 100;
                            img.uploaded = true;
                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;

            },

            uploadSave() {
                let self = this;
                //console.log(this.new_files);
                let unUploadFile = this.new_files.filter(function(file) {
                    //console.log(file.uploaded);
                    return (file.uploaded == false);
                });
                //console.log(unUploadFile);
                if (unUploadFile.length > 0) {
                    this.$confirm('Some file are still not uploaded. Do you want to save all files ?', 'Warning', {
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        type: 'warning'
                    }).then(() => {
                        this.new_files.forEach(function(file) {
                            if (!file.status) {
                                file.status = true;
                            }
                        });
                        // Upload un-uploaded files.
                        for (var i = 0; i < this.new_files.length; i++) {

                            if (this.new_files[i].status == true && this.new_files[i].uploaded == false) {
                                this.new_files[i].progress = 20;
                                this.uploadService(this.new_files[i]).then((path) => {

                                    //save all file in database.
                                    for (var i = 0; i < this.new_files.length; i++) {
                                        let activityData = {
                                            uploader_id: this.userId,
                                            uploaded_by: this.userFullName,
                                        };
                                        let fromData = {
                                            attachable_id: atob(this.$route.params.id),
                                            created_by: this.employeeId,
                                            attachable_type: 'job',
                                            filename: this.new_files[i].name,
                                            description: 'Job Document',
                                            label: this.new_files[i].label,
                                            path: this.new_files[i].path,
                                            activity: JSON.stringify(activityData)
                                        };
                                        this.saveService(fromData).then((res) => {
                                            //console.log(res);
                                            this.$message({
                                                type: 'success',
                                                message: 'File saved successfully'
                                            });
                                            this.new_files = [];
                                        }).catch((err) => {
                                            console.log(err);
                                        });
                                    }

                                }).catch((err) => {
                                    console.log(err);
                                });

                            }
                            //console.log(this.new_files);
                        }
                        //console.log("data");
                    }).catch(() => {

                        /*delete un-uploaded files.*/
                        this.new_files.forEach(function(file, key) {
                            //console.log(key);
                            if (!file.uploaded) {
                                self.new_files.splice(key, 1);
                            }
                        });

                        /* save uploaded files.*/
                        for (var i = 0; i < this.new_files.length; i++) {
                            let activityData = {
                                uploader_id: this.userId,
                                uploaded_by: this.userFullName,
                            };
                            let fromData = {
                                attachable_id: atob(this.$route.params.id),
                                created_by: this.employeeId,
                                attachable_type: 'job',
                                filename: this.new_files[i].name,
                                description: 'Job Document',
                                label: this.new_files[i].label,
                                path: this.new_files[i].path,
                                activity: JSON.stringify(activityData)
                            };
                            this.saveService(fromData).then((res) => {
                                this.$message({
                                    type: 'success',
                                    message: 'File saved successfully'
                                });
                                this.new_files = [];
                            }).catch((err) => {
                                console.log(err);
                            });
                        }
                    });

                } else {
                    //console.log("uploaded");
                    for (var i = 0; i < this.new_files.length; i++) {
                        let activityData = {
                            uploader_id: this.userId,
                            uploaded_by: this.userFullName,
                        };
                        let fromData = {
                            attachable_id: atob(this.$route.params.id),
                            created_by: this.employeeId,
                            attachable_type: 'job',
                            filename: this.new_files[i].name,
                            description: 'Job Document',
                            label: this.new_files[i].label,
                            path: this.new_files[i].path,
                            activity: JSON.stringify(activityData)
                        };
                        this.saveService(fromData).then((res) => {
                            this.$message({
                                type: 'success',
                                message: 'File saved successfully'
                            });
                            this.new_files = [];
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }
                //document.reload();
                this.jobDetails();
            },

            saveService(data) {
                //img.progress = 50;
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment', data, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            resolve(res);
                            this.jobDetails();
                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;

            },

            cancelSave() {
                this.new_files = [];
            },

            cancelUpload() {
                this.count = 0;
                for (this.count = 0; this.count < this.new_files.length; this.count++) {
                    if (this.new_files[this.count].uploaded == false) {
                        this.new_files.splice(this.count, 1);
                    }
                }
            },

            deleteDocuments() {
                this.count = 0;
                for (this.count = 0; this.count < this.new_files.length; this.count++) {
                    if (this.new_files[this.count].status == true) {
                        this.new_files.splice(this.count, 1);
                    }
                }
            },

            async editJob() {
                this.addJob.created_by = this.job.created_by ? this.job.created_by .id : this.userId;
            	this.modalDataLoad=true;
            	this.$modal.show("edit-job");
                service.get('getAllVenue', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((venues) => {
                        // this.venues = venues.data.result;
                        let resVenues = venues.data.result;
                        let venuesList = [];
                        resVenues.forEach((obj) => {
                            if(obj.addresses&&obj.addresses.length) {
                                venuesList.push(obj);
                            }
                        })
                        this.venues = venuesList;
                        //console.log(venues);
                        this.addJob.venue_id = this.job.venue.id;
                        this.addLocationDetails(this.job.venue.id);
                    }).catch((err) => {
                        console.log(err);
                    });
                service.get('employee/getEmployeesByClient', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((employees) => {
                        this.employees = employees.data.result;
                        //console.log(this.employees);
                    }).catch((err) => {
                        console.log(err);
                    });

                service.get('employer/'+this.userClientID+'/getClientEmployerAssociation', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((employers) => {
                        this.employers = employers.data.result;
                        this.addJob.hiring_organization_id = this.job.employer_id;
                        service.get('employer/'+this.addJob.hiring_organization_id+'/getAllEmployerUsersListing', {
	                        'Authorization': this.userToken,
	                        'cs3-context-role': this.userRole,
	                        'cs3-context-clientId': this.userClientID
	                    })
	                    .then((res) => {
							// console.log(this.job.employer_id,res.data.result.employer_users[0].employer_id);
	                        this.employer_users=res.data.result.employer_users;
	                        this.addJob.employer_contact=this.job.employer_user_id;
	                    }).catch((err) => {
	                        console.log(err);
	                    })
                        //console.log(this.employers);
                        // this.addEmployerContact(this.job.hiring_organization_id);
                    }).catch((err) => {
                        console.log(err);
                    });

                service.get('payroll/getPayrollByClient', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    })
                    .then((payrolls) => {
                        this.payrolls = payrolls.data.result.data;
                        //console.log(this.payrolls);

                    }).catch((err) => {
                        console.log(err);
                    });
                   
                let self = this;
                this.addJob.employee_id = ""
                service.get('employee/getStewards', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                })
                .then((stewards) => {
                    this.stewards = stewards.data.result;
                    if(this.stewards&&this.stewards.length&&this.job.employee_id) {
                        let index = this.stewards.findIndex((item)=> item.id == this.job.employee_id);
                        if(index>=0) {
                            this.addJob.employee_id = this.job.employee_id;
                        }else {
                            this.addJob.employee_id = ""
                        }
                    } else if(this.stewards && this.stewards.length) {
                        for(var i=0; i<this.stewards.length; i++){
                            if(this.stewards[i].user_id == this.userId) {
                                self.addJob.employee_id=this.stewards[i].id;
                            }else{
                                self.addJob.employee_id="";
                            }
                        }
                    }
                    this.modalDataLoad=false;
                }).catch((err) => {
                    console.log(err);  
				}); 
                
                this.addJob.dispatched_by = "";	
                		
				await service.get('employee/getDispatchedByList', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                })
                .then((stewards) => {
                    this.dispatchedList = stewards.data.result;                    
                    if(this.job.dispatched_by&&this.job.dispatched_by!=""&&this.dispatchedList&&this.dispatchedList.length) {
                        let index = this.dispatchedList.findIndex((item)=> item.user_id == this.job.dispatched_by.id);
                        if(index>=0) {
                            this.addJob.dispatched_by = this.job.dispatched_by.id;
                        }else {
                            this.addJob.dispatched_by = ""
                        }
                    } else {
                        for(var i=0; i<this.dispatchedList.length; i++){                   
                            if(this.dispatchedList&&this.dispatchedList.length&&this.dispatchedList[i].user_id == this.userId) {                           
                                this.addJob.dispatched_by = this.userId;
                            }else{
                                this.addJob.dispatched_by = ""
                            }
                        }
                    }
                    this.modalDataLoad=false;
                }).catch((err) => {
                    console.log(err);
                    this.modalDataLoad=false;
                }); 

                // service.get('employee/getCreatedByList', {
                //         'Authorization': this.userToken,
                //         'cs3-context-role': this.userRole,
                //         'cs3-context-clientId': this.userClientID
                // })
                // .then((stewards) => {
                //     this.createdByList = stewards.data.result;
                //     this.addJob.created_by = this.job.created_by.id;
                //     //console.log(this.stewards);
                //     this.modalDataLoad=false;
                //     // this.addJob.employee_id = this.job.employee_id;
                //     // this.addJob.created_by = this.job.created_by;
                // }).catch((err) => {
                //     console.log(err);
                //     this.modalDataLoad=false;
                // });
                //this.job = job;
                //this.addJob.hiring_organization_id=this.hiring_organization_id;
                //this.addJob.employer_contact=this.addEmployerContact(this.hiring_organization_id);
                //this.addJob.employee_id=job.employee.employable.id;
                //this.addJob.created_by=job.created_by;
                // this.addJob.venue_id=job.venue.id;
                // this.addJob.location_details=this.addLocationDetails(job.venue.id);

				service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                }).
                then((skills) => {
                    this.positions = skills.data.result;
                }).catch((err) => {
                    console.log(err);
                });
								
                this.addJob.title = this.job.title;
                this.addJob.payroll_id = this.job.payroll_id;
                this.addJob.link_color = "#" + this.job.link_color;
                let getStartDate = this.job.start.split(" ");
                let getEndDate = this.job.end.split(" ");
                this.addJob.start = getStartDate[0];
                this.addJob.end = getEndDate[0];
                this.addJob.employer_requests = this.job.employer_requests;
                this.addJob.employer_requests_private = this.job.employer_requests_private;
                this.addJob.employer_requests_signin = this.job.employer_requests_signin;
                this.addJob.comment = this.job.comment;
                this.addJob.comment_private = (this.job.comment_private == 1) ? true : false;
				this.addJob.hts_flag=this.job.hts_flag;
				this.addJob.steward_access_flag=this.job.steward_access_flag;
                this.addJob.employer_contact=this.job.employer_user_id;
                this.addJob.skill_id1=this.job.skill_id1?this.job.skill_id1:"";
                this.addJob.skill_id2=this.job.skill_id2?this.job.skill_id2:"";
                this.addJob.skill_id3=this.job.skill_id3?this.job.skill_id3:"";
                this.addJob.rate_id=this.job.rate_id?this.job.rate_id:"";
                // this.$modal.show("edit-job");
            },

            getRateName(id) {
                console.log("check123");
                let index = this.rates.findIndex((obj) => obj.id==id)
                if(index > -1) this.rate_table_name = this.rates[index].name;
                else this.rate_table_name = this.rates[index].name;                
            },
            getSkillById(id) {
                let skill = null;
                var item = this.positions.find(item => item.id === id);
                return item.name;
            },

            async editSingleJob() {
                this.$validator.validateAll().then(async(result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        this.editJobFormData = {
                            title: this.addJob.title,
                            employer_id: this.addJob.hiring_organization_id,
                            payroll_id: this.addJob.payroll_id,
                            employer_user_id: this.addJob.employer_contact,
                            link_color: this.getColor(this.addJob.link_color),
                            employee_id: this.addJob.employee_id,
                            created_by: this.addJob.created_by,
                            dispatched_by: this.addJob.dispatched_by,
                            start: this.addJob.start + " " + Date().slice(16, 24),
                            end: this.addJob.end + " " + Date().slice(16, 24),
                            venue_id: this.addJob.venue_id,
                            location_details: this.addJob.location_details,
                            employer_requests: this.addJob.employer_requests,
                            employer_requests_private: this.addJob.employer_requests_private,
                            employer_requests_signin: this.addJob.employer_requests_signin,
                            comment: this.addJob.comment,
                            comment_private: (this.addJob.comment_private) ? 1 : 0,
							serial: '',
							hts_flag:this.addJob.hts_flag,
							steward_access_flag:this.addJob.steward_access_flag,
                            skill_id1: this.addJob.skill_id1 == "" ? null:this.addJob.skill_id1,
                            skill_id2: this.addJob.skill_id2 == "" ? null:this.addJob.skill_id2,
                            skill_id3: this.addJob.skill_id3 == "" ? null:this.addJob.skill_id3,
                            updated_by: this.userId,
                            rate_id: this.addJob.rate_id
                        };
                        this.editJobAction = 'edit-job';
                        this.$modal.hide("edit-job");
                        this.$modal.show("edit-job-add-note");
                        this.editJobAddNote.note = 'Edit Job';
                        // this.openEditJobAddNoteDialog();                        
                        //console.log(this.addJob);
                    } else {
			            this.validation_err = 1;
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Please fill up all required fields.'
                        });
                    }
                });
            },

            async editJobRequest(jobNote) {        
                this.editJobFormData.noteable_id = jobNote.noteable_id;
                this.editJobFormData.noteable_type = jobNote.noteable_type;
                this.editJobFormData.activity = jobNote.activity;
                this.editJobFormData.content = jobNote.content;
                this.modalLoading = true;
                await service.put('job/' + this.job.id, this.editJobFormData, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'userid': this.userId
                }).then((res) => {
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Job Updated Successfully.',
                        type: 'success'
                    });
                    this.$modal.hide("edit-job-add-note");
                    this.editJobAction == '';
                    this.editJobFormData = null;
                    this.jobDetails();
                }).catch((err) => {
                    console.log(err);
                });
                this.modalLoading = false;
            },

            addLocationDetails(id) {
                //console.log(this.venues);
                var index = this.venues.findIndex(venue => venue.id == id);
                //console.log(index);
                if (index != -1) {
                    this.addJob.location_details = (this.venues[index].addresses && this.venues[index].addresses.length>0) ? this.venues[index].addresses[0].address : "NA";
                }
            },

            // addEmployerContact(id) {
            //     //console.log(this.employers);
            //     var index = this.employers.findIndex(employer => employer.employer_id == id);
            //     //console.log(index)
            //     if (index != -1) {
            //         this.addJob.employer_contact = (this.employers[index].employer) ? ((this.employers[index].employer.addresses.length > 0) ? this.employers[index].employer.addresses[0].address : "NA") : "NA";
            //     }
            // },

            addEmployerContact(id) {
                // var index = this.employers.findIndex(employer => employer.employer_id == id);
                // if (index != -1) {
                //     this.addJob.employer_contact = (this.employers[index].employer) ? ((this.employers[index].employer.addresses.length > 0) ? this.employers[index].employer.addresses[0].address : "NA") : "NA";
                // }
                service.get('employer/'+id+'/getAllEmployerUsersListing', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    // this.storeMore = res.data.result.data;
                    // this.next_page = res.data.result.next_page_url;
                    let self =this;
                    this.employer_users=res.data.result.employer_users;
                    this.employer_users.forEach(function(user) {
                        //arr.push(data);
                        if(user.user.role.name == 'Employer Admin'){
                            self.addJob.employer_contact = user.user.id;
                            // console.log(self.addJob.employer_contact);
                        }
                    });


                    // console.log('employer User', res.data.result);

                }).catch((err) => {
                    console.log(err);
                })
            },

            closeEditJob() {
                this.$modal.hide("edit-job");
            },

            deleteAttachment(id) {
                this.$confirm('ATTACHMENT will be removed from the FILES. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('attachment/destroy', {
                        'attachment_id': id
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.jobDetails();
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            deleteJob() {
                var activityID = {
                    "uploader_id": this.userID,
                    "uploaded_by": this.userFullName,
                }
                activityID = JSON.stringify(activityID);
                this.$confirm('Current Job will be removed from the JOBS/EVENT. . Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('job/' + this.job.id + '/softDeleteJobs', {
                        'activity': activityID,
                        'notify': 0
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'userid': this.userID,
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.$router.push({
                            path: `/jobList`
                        });
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            saveBulkCall() {
                var addCallAuth = true;
                let callData = this.addCall.map(call => {
                    let data = {
                        "end": call.date + " " + dateTimeConvert.convertTo24Hours(call.end),
                        "job_id": this.job.id,
                        "quantity": call.quantity,
                        "rate": call.rate,
                        "skill_id": call.position,
                        "start": call.date + " " + dateTimeConvert.convertTo24Hours(call.start),
                        "called_at": call.date + " " + dateTimeConvert.convertTo24Hours(call.start),
                        "notes": call.notes
                    };
                    if (moment(call.start, 'HH:mm A').format('HH:mm:ss')>=moment(call.end, 'HH:mm A').format('HH:mm:ss')) {
                      data.end=moment(data.end, 'YYYY-MM-DD HH:mm:ss').add(1, 'days').format('YYYY-MM-DD HH:mm:ss');
                      //console.log("date Incrised",data.end);
                    }
                    // if (dateTimeConvert.compareTime(call.start, call.end, 12)) {
                    //     addCallAuth = false;
                    //     this.$notify.error({
                    //         title: this.$t('error'),
                    //         message: 'Start time should be greater then end time.'
                    //     });
                    // }
                    return data;
                });
                //console.log(this.addCall[0].date);
                //console.log(callData);
                //addCallAuth=false;
                callData = JSON.stringify(callData);
                service.post('call/storeBulkCall', {
                    'call_array': callData
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$modal.hide("add-call");
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Call Added Successfully.',
                        type: 'success'
                    });
                    //bus.$emit('onSaveNewCall', 'new Call Added');
                    this.$modal.hide("bulk-call");
                }).catch((err) => {
                    console.log(err);
                });
                
                //console.log(callData);
            },

            addBulkCall() {
                // this.$modal.show("bulk-call");
                // this.addCall = [{
                //     date: '',
                //     start: '',
                //     end: '',
                //     quantity: '',
                //     rate: '',
                //     position: '',
                //     notes: ''
                // }];
                // let getStartDate = this.job.start.split(" ");
                // //console.log(getStartDate[0])
                // this.addCall[0].date = getStartDate[0];
                // //console.log(this.job.start);
                // this.getPositions();
                this.$router.push({
                    path:'/addCall/'+ this.$route.params.id
                });
            },

            closeBulkModal() {
                this.$modal.hide("bulk-call");
            },

            openEditRequestCommentModal(title) {
                if(this.userRoleSlug != 'auditor') { 
                    this.edit_request_comment_title = title;
                    this.$modal.show("edit-comment-request-modal");							
                    this.edit_request_comment.employer_requests = this.job ? this.job.employer_requests : "";
                    this.edit_request_comment.calender_comment = this.job ? this.job.comment : "";
                }
            },	

            async modalEditCommentRequestSubmit() {
                this.editJobAddNote.note = this.edit_request_comment_title === 'Employer Request' ? 'Edit Employer Comment' : 'Edit Calendar Comments';
                this.$validator.validateAll().then(async (result) => {
                    if (result) {
                        this.validation_err = 0;
                        this.$modal.hide('edit-comment-request-modal');
                        this.$modal.show('edit-job-add-note');
                        this.editJobAction = 'comments'
                    }else {
                        this.validation_err = 1;
                    }
                });
                // if(this.edit_request_comment_title === 'Employer Request') {
                //   await this.updateEmployerRequest();
                // }else {
                //   await this.updateCalenderComment();
                // }
            },

            async updateCalendarCommentEmployerRequest(jobNote) {
                if(this.edit_request_comment_title === 'Employer Request') {
                  await this.updateEmployerRequest(jobNote);
                }else {
                  await this.updateCalenderComment(jobNote);
                }
            },

            async updateEmployerRequest(jobNote) {
                jobNote.field_type = 'employer_requests';
                jobNote.field_value = this.edit_request_comment.employer_requests;
                await service.post('job/' + this.job.id + '/updateJobField', jobNote, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then(async (res) => {
                    setTimeout(() => {
                        this.$modal.hide('edit-job-add-note');
                    }, 500);
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Employer Request Updated Successfully.',
                        type: 'success'
                    });
                    await this.jobDetails();
                }).catch((err) => {
                    this.$Progress.finish();
                });
			},

			async updateCalenderComment(jobNote) {
                jobNote.field_type = 'comment';
                jobNote.field_value = this.edit_request_comment.calender_comment
                await service.post('job/' + this.job.id + '/updateJobField', jobNote, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then(async (res) => {                            
                    setTimeout(() => {
                        this.$modal.hide('edit-job-add-note');
                    }, 500);
                    this.$notify({
                        title: this.$t('success'),
                        message: 'Comment Updated Successfully.',
                        type: 'success'
                    });
                    
                    await this.jobDetails();
                }).catch((err) => {                           
                    this.$Progress.finish();
                });
            },

            publishEmployerRequest() {
                // this.$Progress.start();
                // var hiring_organization = ''; 
                // var venue = ''; 
                // if (this.jobStatus == "Published") {
                // activity: "{\"uploader_id\":\"5220c9c0-6421-11ed-b2d1-e3b5b0d8dd09\",\"uploaded_by\":\"VL, Sudhakar\"}"
                // content: "Edit Employer Comment checkeing Steward"
                // field_type: "employer_requests"
                // field_value: "<p>Check Employer Request checking steward</p>"
                // noteable_id: "094921f0-500d-11ef-ae9d-d5d577ef1f09"
                // noteable_type: "job"

                var activityID = {
                    "uploader_id": this.userId,
                    "uploaded_by": this.userFullName,
                }
                activityID = JSON.stringify(activityID);
                let jobNote = {
                    noteable_id: this.job.id,
                    noteable_type: 'job',
                    activity: activityID,
                    content: "Hide in Calendar",
                    field_type: 'employer_request_flag',
                    field_value: this.employer_request_flag
                };
                service.post('job/' + this.job.id + '/updateJobField', jobNote, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        message: 'Updated Successfully!'
                    });
                    this.jobDetails();
                    // this.$Progress.finish();
                    //console.log(" Published success=>",job.status.name)
                    // this.job.status.name="Published";
                }).catch((err) => {
                    console.log(err);
                });
                // } 
            },
						
            async publishPrintWithSignIn() {
                // activity: "{\"uploader_id\":\"5220c9c0-6421-11ed-b2d1-e3b5b0d8dd09\",\"uploaded_by\":\"VL, Sudhakar\"}"
                // content: "Edit Employer Comment checkeing Steward"
                // field_type: "employer_requests"
                // field_value: "<p>Check Employer Request checking steward</p>"
                // noteable_id: "094921f0-500d-11ef-ae9d-d5d577ef1f09"
                // noteable_type: "job"
                var activityID = {
                    "uploader_id": this.userId,
                    "uploaded_by": this.userFullName,
                }
                activityID = JSON.stringify(activityID);
                let jobNote = {
                    noteable_id: this.job.id,
                    noteable_type: 'job',
                    activity: activityID,
                    content: "Print with SignIn",
                    field_type: 'employer_requests_signin',
                    field_value: this.employer_requests_signin
                };
                
                await service.post('job/' + this.job.id + '/updateJobField', jobNote, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        message: 'Updated Successfully!'
                    });
                    this.jobDetails();
                    this.job.status.name="Published";
                }).catch((err) => {
                    console.log(err);
                });                
            },

			closeEditCommentRequesstModal() {
                this.$modal.hide("edit-comment-request-modal");
            },	

            addNewGroup() {
                var temp = {
                    date: this.addCall[0].date,
                    start: this.addCall[0].start,
                    end: this.addCall[0].end,
                    quantity: '',
                    rate: this.addCall[0].rate,
                    position: this.addCall[0].position,
                    notes: ''
                };
                this.addCall.push(temp);
            },

            removeGroup(key) {
                this.addCall.splice(key, 1);
            },

            onInputchangeCheckbox() {
                this.addCall = [{
                    date: '',
                    start: '',
                    end: '',
                    quantity: '',
                    rate: '',
                    position: '',
                    notes: ''
                }];

                let getStartDate = this.job.start.split(" ");
                //console.log(getStartDate[0])
                this.addCall[0].date = getStartDate[0];
            },

            getPositions() {
                //console.log("getPositions called..");
               
                service.get('skill/getAllSkills', {
                    'Authorization': this.userToken,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    this.positions = res.data.result;
                }).catch((err) => {
                    console.log(err);
                });
            },

            async getClient(){
                await service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken
                }).
                then((res) => {
                    this.clientData = res.data.result;
                    this.global_skills = this.clientData.global_skills;
                    this.estimate_payroll_button = this.clientData.estimate_payroll_button;
                    this.setGlobalTimeout(res.data.result.phonesheet_ts);
                    this.config_arr = Object.values(res.data.result.settings['job-info-config-future']);
                    this.selectedSortType=this.clientData.default_employee_sort;
                }).catch((err) => {
                    console.log(err);
                });
            },

            getEmpDetails() {
                this.$Progress.start();
                service.get('employee/' + this.employeeId, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.$Progress.finish();
                    this.userDateFormat = res.data.result.date_format;
                    this.userTimeFormat = res.data.result.time_format;
                    // console.log(this.userDateFormat,this.userTimeFormat)
                }).catch((err) => {
                    console.log(err);
                });
            },

            displayEmployerContact(job){
                let employerContact = '';
                if(job.employer&&job.employer.employer_users&&job.employer.employer_users.length){
                    job.employer.employer_users.forEach((employerUser) => {
                        if(employerUser.user.id == job.employer_user_id) {
                            employerContact = ' ' +employerUser.user.first_name + ' ' + employerUser.user.last_name;
                        }
                    })
                }
                return employerContact;
            },

            payrollEstimateTemplate() {
                // console.log("payrollEstimateTemplate");

                this.loading = true;
				 service.get('call/payrollJsonPayload',{
					'Authorization': this.userToken,
					'cs3-context-role': this.userRole,
					'cs3-context-clientId': this.userClientID,
					'job-id': atob(this.$route.params.id),
				}).then(res =>{
					console.log(res);
					this.loading = false;
					let redirectUrl = dateTimeConvert.getSignInSheetUrl('jobReports/');
					window.open(redirectUrl, "_blank");  					
				}).catch(err =>{
					this.loading = false;
					console.log(err);
				})

            },

            async downloadGsheet() {
                // console.log("downloadGsheet");
                this.loading = true;
                await service.post('jobDataToGdrive', {
                   job_id: this.job.id
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    // this.jobDetails();
                    // this.job.status.name="Published";
                    // console.log(res.status);
                    this.loading = false;
                    if(res.status&&res.status==200&&res.data){
                        this.$notify.success({
                            message: res.data.status_message,
                            title: 'Success'
                        })
                    }
                }).catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
                // result.download("exportedreport.pdf");
            },

            getRates() {
                service.get('getRates', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                })
                .then((res) => {
                    this.rates = res.data.result;
                    console.log(this.rates);
                }).catch((err) => {
                    console.log(err);
                });
            },
        },

        async create() {
            await this.checkSteward();
        },
        async mounted() {
            this.getBaseURL = global[0].IMAGE_URL;
            this.job = null;            
            var id = btoa(this.$route.params);
            this.getRates();
            await this.jobDetails();
            if(this.job) {
                document.title = `${this.job.job_number}#${this.job.title}`;  
            }         
            this.config_arr = [];
            await this.getClient();            
			this.getPositions();
            // if(this.userRoleSlug == 'client-admin'){
            // await this.getClientData();
            // }
            this.getEmpDetails();
            $(this.$el).find('input').datetimepicker(this.config)
            .on('dp.show', (e) => {
                const picker = e.target; // Reference to the picker element
                const currentTime = moment();

                // Check if the input is empty and set the current time in the picker
                if (!picker.value) {
                    $(picker).data('DateTimePicker').date(currentTime);
                }
            });
        },
        beforeMount() {
            this.job = null;   
        }, 
        beforeDestroy()  {
            this.job =null;
        },
        destroyed() {
            this.job = null;
        }
    }

</script>
<style scoped>
    .mr1px {
        margin-right: 1px;
    }
    .greyBg {
        background-color: grey!important;
    }
    .c-common-btn--small.gsheet{
        display: inline-flex;
        flex-direction: row;
        padding: 6px 10px;
    }

    .gsheet-logo{
        height: 20px;
        width: 20px;
        margin-right: 5px;
    }
    .gsheet-text{
       padding: 0;
       margin-top: 3px;
       font-size: 16px;
    }
    .loading-block {
        min-width: 400px;
        min-height: 400px;
        margin: 50px auto;
    }
    .fixed-height-box{
        max-height: 600px;
        overflow-y: auto;
        margin-bottom: 15px;
        box-shadow: 2px 2px 2px 2px #d5d5da;
        margin-top: 3px;
    }
    .time-out-part {
        width: 45px;
        display: inline;
        height: 30px;
    }
    
    .job-details-call-timeout {
        text-align: center;
        border-radius: 5px;
        border: #232324 1px solid;
        appearance: none;
        -ms-appearance: none;
        -moz-appearance: none;
        -o-appearance: none;
        height: 32px;
        width: 12%;
        padding: 5px;
        color: #2c2b2b;
        font-size: 14px;
        outline: none;
        background: white;
        margin: 1px 1px 5px;
        /* -webkit-appearance: none; */
    }
    .job-details-call-timeout-disable {
        text-align: center;
        border-radius: 5px;
        border: #b8b8b8 1px solid;
        appearance: none;
        -ms-appearance: none;
        -moz-appearance: none;
        -o-appearance: none;
        height: 32px;
        width: 12%;
        padding: 5px;
        color: #686666;
        font-size: 14px;
        outline: none;
        background: #f4f7f8;
        margin: 1px 1px 5px;
        /* -webkit-appearance: none; */
    }

	sup{
		color: red;
	}
	.created-time-width{
		width:40%;
	}
	.action-icon-doc-width{
		width:60%;
	}
	.phonesheet-time-out{
	    padding:3px;
	    display:inline;
	    line-height: 35px;
	}
	.phonesheet-time-out select{
	    width:45px;
	    display:inline;
	    height: 30px;
	}
	.share-access-style{
		font-size: 14px;
	}
	.share-access-style input{
		margin-left:10px;
	}
	.o-ndividualTable--small {
		padding: 0px;
	}
	.min-with-select-box{
        min-width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/components/jobs/jobDetails.vue